var _defs, _ellipse, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _image, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _image2, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _image3, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _image4, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHero2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 549.31,
    height: 308.106,
    viewBox: "0 0 549.31 308.106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.05,
    y1: 0.5,
    x2: 0.95,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff698e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff698e",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b4384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a7fab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.233,
    y1: 0.978,
    x2: 1.007,
    y2: -0.497,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ff9797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#fd8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fb6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#f72626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.975,
    y1: 0.188,
    x2: 0.01,
    y2: 0.587,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abc4fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5edfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.99,
    y1: 0.104,
    x2: 0.494,
    y2: 0.57,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.762,
    y1: 0.809,
    x2: 0.14,
    y2: 0.214,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#fe9090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#fd7e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#fb6060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897,
    stopColor: "#f83737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f72626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.164,
    y1: 0.062,
    x2: 0.866,
    y2: 0.978,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a52f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cd86f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.568,
    y1: 0.469,
    x2: 0.766,
    y2: 0.344,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a52f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#5a59f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#5a80f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5a98f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5aa1f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -0.009,
    y1: 0.095,
    x2: 1.113,
    y2: 1.087,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.47,
    y1: 0.537,
    x2: 0.789,
    y2: 0.391,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a52f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#5a6cf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#5a89f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#5a9af0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5aa1f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.252,
    y1: 0.163,
    x2: 0.826,
    y2: 0.942,
    xlinkHref: "#linear-gradient-8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4071",
    "data-name": "Group 4071",
    transform: "translate(-660.638 -1659.561)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 246.426,
    cy: 15.347,
    rx: 246.426,
    ry: 15.347,
    transform: "translate(685.671 1936.973)",
    fill: "#f0efff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4070",
    "data-name": "Group 4070"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3730",
    "data-name": "Group 3730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3725",
    "data-name": "Group 3725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3724",
    "data-name": "Group 3724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5590",
    "data-name": "Path 5590",
    d: "M1004.389,1663.2c-96.505-16.426-219.7,22.586-219.017,121.144-110.192,26.008-119.774,111.561-93.766,167h463.356C1210.4,1782.288,1100.893,1679.624,1004.389,1663.2Z",
    fill: "#f1f0ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3727",
    "data-name": "Group 3727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3726",
    "data-name": "Group 3726"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 60.229,
    cy: 60.229,
    r: 60.229,
    transform: "translate(666.282 1670.727)",
    fill: "#f2f1ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3728",
    "data-name": "Group 3728"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 25.324,
    cy: 25.324,
    r: 25.324,
    transform: "translate(751.151 1667.989)",
    fill: "#e6e6f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3729",
    "data-name": "Group 3729"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 31.484,
    cy: 31.484,
    r: 31.484,
    transform: "translate(1134.198 1844.708) rotate(-76.717)",
    fill: "#e6e6f4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3737",
    "data-name": "Group 3737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3732",
    "data-name": "Group 3732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3731",
    "data-name": "Group 3731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5591",
    "data-name": "Path 5591",
    d: "M958.639,1915.488a.731.731,0,0,1-.037-1.462c1.117-.058,2.257-.132,3.389-.221a.732.732,0,0,1,.113,1.459c-1.144.09-2.3.165-3.426.223Z",
    fill: "#f72626"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3734",
    "data-name": "Group 3734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3733",
    "data-name": "Group 3733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5592",
    "data-name": "Path 5592",
    d: "M951.865,1915.665h0c-2.269,0-4.561-.062-6.812-.183a.732.732,0,0,1,.079-1.461c2.225.119,4.49.18,6.734.18a.732.732,0,0,1,0,1.464Zm-13.525-.727a.7.7,0,0,1-.08,0c-2.26-.245-4.532-.555-6.754-.922a.732.732,0,1,1,.239-1.444c2.2.362,4.44.669,6.673.911a.732.732,0,0,1-.078,1.459Zm-13.365-2.212a.744.744,0,0,1-.161-.018c-2.224-.5-4.446-1.07-6.606-1.693a.732.732,0,0,1,.406-1.407c2.132.616,4.326,1.178,6.521,1.672a.732.732,0,0,1-.16,1.446Zm-13.012-3.763a.74.74,0,0,1-.247-.043c-2.155-.771-4.29-1.615-6.346-2.508a.732.732,0,1,1,.583-1.342c2.027.88,4.132,1.712,6.256,2.472a.732.732,0,0,1-.246,1.421Zm-12.419-5.4a.735.735,0,0,1-.338-.083c-2.04-1.063-4.037-2.2-5.935-3.381a.732.732,0,1,1,.773-1.243c1.867,1.162,3.831,2.28,5.838,3.326a.732.732,0,0,1-.338,1.381Zm-11.488-7.165a.733.733,0,0,1-.437-.144c-1.856-1.382-3.638-2.839-5.3-4.331a.732.732,0,1,1,.979-1.088c1.624,1.462,3.371,2.89,5.191,4.245a.731.731,0,0,1-.437,1.318Zm-10.04-9.068a.732.732,0,0,1-.544-.241,58.141,58.141,0,0,1-4.289-5.35.732.732,0,0,1,1.2-.845,56.889,56.889,0,0,0,4.181,5.215.731.731,0,0,1-.543,1.221ZM911,1883.319h-.017a54.575,54.575,0,0,1-6.839-.6.732.732,0,0,1,.218-1.448,52.983,52.983,0,0,0,6.655.587.732.732,0,0,1-.017,1.463Zm6.759-.353a.732.732,0,0,1-.1-1.457,32.985,32.985,0,0,0,6.443-1.506.732.732,0,0,1,.482,1.382,34.416,34.416,0,0,1-6.73,1.574A.659.659,0,0,1,917.76,1882.966Zm-20.14-1.617a.748.748,0,0,1-.186-.024c-2.169-.571-4.365-1.266-6.528-2.066a.732.732,0,0,1,.508-1.373c2.118.784,4.269,1.465,6.392,2.024a.731.731,0,0,1-.186,1.439Zm32.778-2.929a.731.731,0,0,1-.413-1.336,20.756,20.756,0,0,0,4.754-4.455.732.732,0,1,1,1.158.9,22.2,22.2,0,0,1-5.088,4.769A.728.728,0,0,1,930.4,1878.42Zm-45.479-1.756a.738.738,0,0,1-.315-.071c-2.045-.976-4.076-2.058-6.037-3.217a.732.732,0,0,1,.744-1.26c1.924,1.137,3.917,2.2,5.923,3.156a.731.731,0,0,1-.315,1.392Zm-14.669-.392a.732.732,0,0,1-.65-.394,45.043,45.043,0,0,1-2.707-6.322.732.732,0,0,1,1.387-.469,43.647,43.647,0,0,0,2.618,6.115.732.732,0,0,1-.648,1.07Zm3.012-6.494a.725.725,0,0,1-.426-.137c-1.856-1.33-3.664-2.753-5.375-4.229a.732.732,0,1,1,.957-1.108c1.677,1.448,3.451,2.843,5.27,4.147a.732.732,0,0,1-.426,1.327Zm65.285-1.891a.722.722,0,0,1-.249-.044.731.731,0,0,1-.439-.937c.212-.586.406-1.2.575-1.816a45.878,45.878,0,0,0,1.013-4.623.732.732,0,1,1,1.444.238,47.365,47.365,0,0,1-1.045,4.772c-.18.657-.386,1.3-.611,1.927A.732.732,0,0,1,938.547,1867.887Zm-72.589-4.394a.732.732,0,0,1-.722-.617,38.876,38.876,0,0,1-.482-6.082q0-.394.008-.792a.732.732,0,0,1,1.464.03c-.006.255-.008.509-.008.762a37.522,37.522,0,0,0,.463,5.852.73.73,0,0,1-.607.837A.661.661,0,0,1,865.958,1863.493Zm-2.934-2.561a.73.73,0,0,1-.528-.225c-1.588-1.654-3.1-3.39-4.494-5.161a.732.732,0,0,1,1.15-.906c1.365,1.734,2.845,3.434,4.4,5.053a.732.732,0,0,1-.527,1.239Zm77.756-6.357h-.013a.73.73,0,0,1-.718-.744q.006-.384.006-.765a45.151,45.151,0,0,0-.386-5.886.732.732,0,1,1,1.451-.191,46.489,46.489,0,0,1,.4,6.077c0,.263,0,.526-.007.79A.732.732,0,0,1,940.78,1854.575Zm-86.112-4.28a.732.732,0,0,1-.619-.341,63.372,63.372,0,0,1-3.341-5.981.732.732,0,0,1,1.315-.643,62.024,62.024,0,0,0,3.263,5.843.731.731,0,0,1-.228,1.009A.722.722,0,0,1,854.668,1850.3Zm11.567-.272a.719.719,0,0,1-.144-.015.732.732,0,0,1-.574-.861c.175-.876.384-1.763.62-2.637a38.941,38.941,0,0,1,1.313-3.982.732.732,0,0,1,1.363.533,37.468,37.468,0,0,0-1.263,3.831c-.228.843-.429,1.7-.6,2.543A.733.733,0,0,1,866.235,1850.023Zm72.772-8.833a.732.732,0,0,1-.7-.528,41.862,41.862,0,0,0-2.353-6.222.732.732,0,1,1,1.323-.626,43.482,43.482,0,0,1,2.436,6.44.733.733,0,0,1-.5.907A.723.723,0,0,1,939.007,1841.19Zm-90.27-3.044a.731.731,0,0,1-.689-.487,60.114,60.114,0,0,1-1.93-6.574.732.732,0,1,1,1.425-.332,58.933,58.933,0,0,0,1.883,6.415.733.733,0,0,1-.689.978Zm22.394-.686a.731.731,0,0,1-.625-1.111,41.94,41.94,0,0,1,4.047-5.575.732.732,0,0,1,1.11.954,40.593,40.593,0,0,0-3.906,5.379A.731.731,0,0,1,871.131,1837.46Zm62.08-8.452a.729.729,0,0,1-.6-.31,34.892,34.892,0,0,0-4.308-5.035.732.732,0,1,1,1.015-1.055,36.474,36.474,0,0,1,4.489,5.247.732.732,0,0,1-.177,1.019A.723.723,0,0,1,933.211,1829.008Zm-53.3-1.794a.732.732,0,0,1-.474-1.29q.361-.306.729-.6c1.568-1.272,3.164-2.457,4.742-3.522a.732.732,0,1,1,.819,1.213c-1.543,1.041-3.1,2.2-4.638,3.445-.237.193-.473.387-.706.585A.729.729,0,0,1,879.913,1827.214Zm-34.251-2.231a.731.731,0,0,1-.723-.63c-.315-2.222-.711-4.448-1.177-6.614a.731.731,0,1,1,1.43-.308c.474,2.2.876,4.46,1.2,6.717a.737.737,0,0,1-.726.835Zm77.816-5.271a.73.73,0,0,1-.384-.109,28.745,28.745,0,0,0-5.962-2.807.732.732,0,1,1,.466-1.387,30.167,30.167,0,0,1,6.266,2.949.732.732,0,0,1-.386,1.354Zm-32.328-.019a.732.732,0,0,1-.331-1.385,44.965,44.965,0,0,1,6.353-2.645.731.731,0,1,1,.453,1.391,43.4,43.4,0,0,0-6.145,2.56A.735.735,0,0,1,891.15,1819.693Zm12.844-4.1a.731.731,0,0,1-.092-1.457,31.92,31.92,0,0,1,6.917-.143.732.732,0,0,1-.132,1.458,30.439,30.439,0,0,0-6.6.136A.748.748,0,0,1,903.994,1815.588Zm-61.186-3.833a.73.73,0,0,1-.7-.525c-.632-2.147-1.352-4.288-2.139-6.365a.732.732,0,1,1,1.368-.519c.8,2.111,1.533,4.289,2.175,6.471a.732.732,0,0,1-.5.908A.706.706,0,0,1,842.808,1811.755Zm-4.8-12.651a.733.733,0,0,1-.663-.421c-.95-2.019-1.992-4.023-3.1-5.957a.732.732,0,0,1,1.272-.725c1.122,1.967,2.181,4.005,3.149,6.059a.733.733,0,0,1-.662,1.044Zm-145.759-8.735a.733.733,0,0,1-.674-1.014c.885-2.12,1.865-4.2,2.913-6.186a.732.732,0,0,1,1.294.683c-1.027,1.946-1.988,3.987-2.857,6.067A.732.732,0,0,1,692.25,1790.369ZM831.3,1787.35a.729.729,0,0,1-.605-.32c-1.254-1.842-2.6-3.659-3.993-5.4a.732.732,0,0,1,1.142-.916c1.42,1.77,2.786,3.618,4.061,5.492a.732.732,0,0,1-.6,1.143Zm-132.724-8.938a.721.721,0,0,1-.4-.121.731.731,0,0,1-.21-1.013,67.982,67.982,0,0,1,4.043-5.523.731.731,0,1,1,1.135.923,66.737,66.737,0,0,0-3.955,5.4A.73.73,0,0,1,698.577,1778.412Zm124.258-1.622a.732.732,0,0,1-.534-.231c-1.524-1.624-3.134-3.212-4.786-4.72a.732.732,0,1,1,.987-1.081c1.679,1.533,3.316,3.148,4.866,4.8a.732.732,0,0,1-.533,1.233Zm-115.721-8.867a.731.731,0,0,1-.516-1.25,64.92,64.92,0,0,1,5.1-4.574.732.732,0,1,1,.919,1.139,63.716,63.716,0,0,0-4.982,4.471A.733.733,0,0,1,707.114,1767.923Zm105.719-.27a.728.728,0,0,1-.45-.156c-1.754-1.372-3.586-2.7-5.446-3.942a.732.732,0,0,1,.814-1.217c1.89,1.264,3.752,2.612,5.534,4.007a.732.732,0,0,1-.452,1.308Zm-11.26-7.529a.735.735,0,0,1-.36-.095c-1.941-1.1-3.95-2.141-5.969-3.1a.732.732,0,0,1,.625-1.323c2.052.97,4.093,2.028,6.065,3.145a.732.732,0,0,1-.361,1.369Zm-83.932-.692a.732.732,0,0,1-.4-1.346,66.971,66.971,0,0,1,5.932-3.412.732.732,0,0,1,.664,1.3,65.158,65.158,0,0,0-5.8,3.337A.725.725,0,0,1,717.641,1759.432Zm71.686-5.1a.724.724,0,0,1-.264-.05c-2.085-.8-4.224-1.541-6.358-2.188a.731.731,0,0,1,.425-1.4c2.168.657,4.342,1.4,6.46,2.223a.732.732,0,0,1-.263,1.415Zm-59.64-1.042a.732.732,0,0,1-.265-1.414c2.1-.819,4.285-1.55,6.488-2.174a.732.732,0,1,1,.4,1.408c-2.159.611-4.3,1.328-6.356,2.13A.732.732,0,0,1,729.687,1753.292Zm46.677-2.891a.745.745,0,0,1-.161-.018c-2.186-.489-4.41-.9-6.611-1.219a.732.732,0,0,1,.211-1.449c2.237.326,4.5.743,6.72,1.24a.732.732,0,0,1-.159,1.446Zm-33.658-.8a.732.732,0,0,1-.134-1.451c2.216-.414,4.495-.736,6.773-.958a.731.731,0,0,1,.142,1.456c-2.236.218-4.472.535-6.646.94A.7.7,0,0,1,742.706,1749.6Zm20.253-1.141-.05,0c-2.241-.15-4.5-.211-6.716-.18a.732.732,0,1,1-.02-1.463c2.259-.031,4.554.031,6.834.183a.732.732,0,0,1-.048,1.462Z",
    fill: "#f72626"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3736",
    "data-name": "Group 3736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3735",
    "data-name": "Group 3735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5593",
    "data-name": "Path 5593",
    d: "M688.877,1800.157a.733.733,0,0,1-.705-.928c.308-1.109.639-2.219.986-3.3a.732.732,0,0,1,1.394.446c-.341,1.062-.667,2.154-.97,3.245A.733.733,0,0,1,688.877,1800.157Z",
    fill: "#f72626"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3742",
    "data-name": "Group 3742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3739",
    "data-name": "Group 3739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3738",
    "data-name": "Group 3738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5594",
    "data-name": "Path 5594",
    d: "M955.4,1952.425c6.378-37.382-13.819-75.827-43.938-82.56-5.315,47.481,27.461,82.915,27.461,82.915Z",
    fill: "#c0beed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3741",
    "data-name": "Group 3741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3740",
    "data-name": "Group 3740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5595",
    "data-name": "Path 5595",
    d: "M938.921,1952.78s-32.776-35.434-27.461-82.915c0,0,29.1,48.566,37.36,82.7Z",
    fill: "#e1defb"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3744",
    "data-name": "Group 3744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3743",
    "data-name": "Group 3743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5596",
    "data-name": "Path 5596",
    d: "M933.412,1785.84a.727.727,0,0,1-.4-.119c-1.964-1.274-3.852-2.621-5.611-4a.731.731,0,0,1,.9-1.151c1.726,1.353,3.577,2.674,5.505,3.925a.732.732,0,0,1-.4,1.346ZM922.7,1777.4a.73.73,0,0,1-.508-.206,59.684,59.684,0,0,1-4.691-5.072.732.732,0,0,1,1.132-.928,58.312,58.312,0,0,0,4.575,4.947.732.732,0,0,1-.508,1.259Zm-8.615-10.55a.731.731,0,0,1-.622-.345,49.528,49.528,0,0,1-3.247-6.116.732.732,0,1,1,1.338-.593,48.049,48.049,0,0,0,3.151,5.935.732.732,0,0,1-.62,1.119Zm-5.5-12.451a.732.732,0,0,1-.7-.536,46.97,46.97,0,0,1-1.349-6.8.731.731,0,1,1,1.452-.178,45.706,45.706,0,0,0,1.307,6.586.73.73,0,0,1-.705.927Zm-1.665-13.505h-.017a.73.73,0,0,1-.715-.747,51.033,51.033,0,0,1,.624-6.889.731.731,0,1,1,1.445.229,49.781,49.781,0,0,0-.606,6.692A.733.733,0,0,1,906.922,1740.9Zm2.114-13.447a.725.725,0,0,1-.205-.029.733.733,0,0,1-.5-.908,59.312,59.312,0,0,1,2.325-6.507.731.731,0,1,1,1.347.571,57.989,57.989,0,0,0-2.267,6.346A.731.731,0,0,1,909.036,1727.448Zm5.3-12.556a.732.732,0,0,1-.639-1.089,68.221,68.221,0,0,1,3.671-5.844.732.732,0,0,1,1.2.84,66.35,66.35,0,0,0-3.592,5.718A.731.731,0,0,1,914.336,1714.892Zm127.888-5.792a.73.73,0,0,1-.541-.239l-.5-.541a.731.731,0,1,1,1.074-.993l.5.547a.733.733,0,0,1-.54,1.226Zm-120.072-5.384a.731.731,0,0,1-.555-1.207c1.48-1.731,3.07-3.422,4.722-5.025a.732.732,0,1,1,1.019,1.05c-1.62,1.572-3.178,3.229-4.63,4.926A.728.728,0,0,1,922.152,1703.716Zm114.8-.049a.731.731,0,0,1-.51-.207c-1.639-1.591-3.322-3.132-5-4.581a.732.732,0,0,1,.955-1.109c1.7,1.468,3.408,3.029,5.068,4.64a.732.732,0,0,1-.51,1.257Zm-10.346-8.9a.727.727,0,0,1-.441-.148c-1.818-1.374-3.683-2.685-5.543-3.9a.732.732,0,1,1,.8-1.226c1.888,1.23,3.781,2.561,5.627,3.955a.732.732,0,0,1-.442,1.316Zm-94.668-.55a.732.732,0,0,1-.46-1.3c1.779-1.438,3.647-2.813,5.551-4.087a.732.732,0,0,1,.814,1.217c-1.868,1.249-3.7,2.6-5.446,4.008A.725.725,0,0,1,931.942,1694.215Zm83.228-6.888a.718.718,0,0,1-.351-.091c-1.991-1.093-4.029-2.11-6.057-3.02a.732.732,0,1,1,.6-1.335c2.063.926,4.136,1.96,6.161,3.072a.732.732,0,0,1-.353,1.374Zm-71.891-.7a.732.732,0,0,1-.352-1.374c2.013-1.1,4.1-2.119,6.192-3.029a.732.732,0,1,1,.583,1.342c-2.055.893-4.1,1.892-6.073,2.971A.727.727,0,0,1,943.279,1686.628Zm59.443-4.878a.731.731,0,0,1-.242-.041c-2.134-.748-4.313-1.4-6.474-1.949a.732.732,0,0,1,.359-1.419c2.2.556,4.423,1.225,6.6,1.986a.732.732,0,0,1-.242,1.423Zm-46.932-.552a.732.732,0,0,1-.229-1.427c2.181-.718,4.416-1.341,6.642-1.85a.732.732,0,1,1,.326,1.427c-2.182.5-4.372,1.109-6.51,1.813A.73.73,0,0,1,955.79,1681.2Zm33.708-2.782a.729.729,0,0,1-.113-.009c-2.224-.347-4.484-.592-6.718-.727a.732.732,0,0,1,.088-1.461c2.28.138,4.587.388,6.855.742a.732.732,0,0,1-.112,1.455Zm-20.415-.257a.732.732,0,0,1-.094-1.457c2.272-.3,4.584-.49,6.87-.57a.732.732,0,0,1,.052,1.463c-2.241.078-4.506.266-6.732.558A.769.769,0,0,1,969.083,1678.159Z",
    fill: "#f72626"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3747",
    "data-name": "Group 3747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3745",
    "data-name": "Group 3745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5597",
    "data-name": "Path 5597",
    d: "M743.729,1945.659c-4.433-29.929,15.8-44.062,40.46-45.725,4.434,23.555-1.94,41.845-18.567,47.942Z",
    fill: "#486ae0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3746",
    "data-name": "Group 3746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5598",
    "data-name": "Path 5598",
    d: "M765.622,1947.876c16.627-6.1,23-24.387,18.567-47.942l-31.5,46.632Z",
    fill: "#6f8fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3752",
    "data-name": "Group 3752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3749",
    "data-name": "Group 3749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3748",
    "data-name": "Group 3748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5599",
    "data-name": "Path 5599",
    d: "M751.136,1947.711c12.965-75.989-28.091-154.138-89.313-167.823-10.8,96.516,55.82,168.543,55.82,168.543Z",
    fill: "#e0def9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3751",
    "data-name": "Group 3751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3750",
    "data-name": "Group 3750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5600",
    "data-name": "Path 5600",
    d: "M717.644,1948.431s-66.625-72.027-55.821-168.543c0,0,59.161,98.721,75.942,168.11Z",
    fill: "#c0beed"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3757",
    "data-name": "Group 3757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3754",
    "data-name": "Group 3754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3753",
    "data-name": "Group 3753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5601",
    "data-name": "Path 5601",
    d: "M725.927,1948.431c5.762-38.9-20.528-57.261-52.58-59.422-5.762,30.611,2.521,54.38,24.129,62.3Z",
    fill: "#e0def9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3756",
    "data-name": "Group 3756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3755",
    "data-name": "Group 3755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5602",
    "data-name": "Path 5602",
    d: "M697.476,1951.312c-21.608-7.923-29.891-31.692-24.129-62.3l40.938,60.6Z",
    fill: "#c0beed"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3772",
    "data-name": "Group 3772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3767",
    "data-name": "Group 3767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3758",
    "data-name": "Group 3758"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 4.429,
    cy: 4.429,
    r: 4.429,
    transform: "translate(739.494 1936.691)",
    fill: "#313a43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3759",
    "data-name": "Group 3759"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 2.475,
    cy: 2.475,
    r: 2.475,
    transform: "translate(741.448 1938.645)",
    fill: "#616f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3760",
    "data-name": "Group 3760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5603",
    "data-name": "Path 5603",
    d: "M746.147,1935h0a4.494,4.494,0,0,1,4.494,4.494v1.136H729.79l-1.075-5.63Z",
    fill: "#616f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3761",
    "data-name": "Group 3761"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 4.429,
    cy: 4.429,
    r: 4.429,
    transform: "translate(707.372 1936.691)",
    fill: "#313a43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3762",
    "data-name": "Group 3762"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 2.475,
    cy: 2.475,
    r: 2.475,
    transform: "translate(709.517 1938.645)",
    fill: "#616f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3763",
    "data-name": "Group 3763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5604",
    "data-name": "Path 5604",
    d: "M709.576,1935h0a4.494,4.494,0,0,0-4.494,4.494v1.136h20.851l1.075-5.63Z",
    fill: "#616f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3764",
    "data-name": "Group 3764"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 5.861,
    height: 56.529,
    transform: "translate(724.743 1883.712)",
    fill: "#313a43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3765",
    "data-name": "Group 3765"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 7.229,
    height: 6.773,
    transform: "translate(724.059 1938.743)",
    fill: "#404b54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3766",
    "data-name": "Group 3766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5605",
    "data-name": "Path 5605",
    d: "M727.673,1935h0a4.494,4.494,0,0,1,4.494,4.494v1.136H723.18v-1.136A4.494,4.494,0,0,1,727.673,1935Z",
    fill: "#313a43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3768",
    "data-name": "Group 3768"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 36.397,
    height: 53.705,
    rx: 13.565,
    transform: "translate(705.433 1846.193)",
    fill: "#6e7a7f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3769",
    "data-name": "Group 3769"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 8.527,
    height: 53.705,
    rx: 3.884,
    transform: "translate(704.784 1844.922)",
    fill: "#313a43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3770",
    "data-name": "Group 3770"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 43.27,
    height: 8.145,
    rx: 3.71,
    transform: "translate(723.768 1897.736)",
    fill: "#ff7b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3771",
    "data-name": "Group 3771"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 43.27,
    height: 8.145,
    rx: 3.71,
    transform: "translate(703.766 1897.736)",
    fill: "#616f77"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3789",
    "data-name": "Group 3789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3783",
    "data-name": "Group 3783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3773",
    "data-name": "Group 3773"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 4.429,
    cy: 4.429,
    r: 4.429,
    transform: "translate(821.451 1936.691)",
    fill: "#404b54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3775",
    "data-name": "Group 3775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3774",
    "data-name": "Group 3774"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 2.475,
    cy: 2.475,
    r: 2.475,
    transform: "translate(823.405 1938.645)",
    fill: "#616f77"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3776",
    "data-name": "Group 3776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5606",
    "data-name": "Path 5606",
    d: "M828.1,1935h0a4.494,4.494,0,0,1,4.494,4.494v1.136H811.748l-1.075-5.63Z",
    fill: "#616f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3777",
    "data-name": "Group 3777"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 4.429,
    cy: 4.429,
    r: 4.429,
    transform: "translate(789.33 1936.691)",
    fill: "#404b54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3778",
    "data-name": "Group 3778"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 2.475,
    cy: 2.475,
    r: 2.475,
    transform: "translate(791.475 1938.645)",
    fill: "#616f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3779",
    "data-name": "Group 3779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5607",
    "data-name": "Path 5607",
    d: "M792.388,1935h0a4.494,4.494,0,0,0-4.494,4.494v1.136h20.851l1.075-5.63Z",
    fill: "#616f77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3780",
    "data-name": "Group 3780"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 5.861,
    height: 66.286,
    transform: "translate(806.7 1873.955)",
    fill: "#313a43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3781",
    "data-name": "Group 3781"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 7.229,
    height: 6.773,
    transform: "translate(806.017 1938.743)",
    fill: "#404b54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3782",
    "data-name": "Group 3782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5608",
    "data-name": "Path 5608",
    d: "M809.631,1935h0a4.494,4.494,0,0,1,4.494,4.494v1.136h-8.988v-1.136A4.494,4.494,0,0,1,809.631,1935Z",
    fill: "#313a43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3784",
    "data-name": "Group 3784"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 36.397,
    height: 53.705,
    rx: 13.565,
    transform: "translate(786.742 1835.165)",
    fill: "#6e7a7f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3785",
    "data-name": "Group 3785"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 8.527,
    height: 53.705,
    rx: 3.884,
    transform: "translate(786.742 1835.165)",
    fill: "#313a43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3786",
    "data-name": "Group 3786"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 43.27,
    height: 8.145,
    rx: 3.71,
    transform: "translate(805.726 1887.979)",
    fill: "#6e87e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3788",
    "data-name": "Group 3788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3787",
    "data-name": "Group 3787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5609",
    "data-name": "Path 5609",
    d: "M789.472,1896.124h35.774a3.748,3.748,0,0,0,3.748-3.748v-.65c0-2.069-1.678-3.747-2.893-3.747H790.326c-2.924,0-4.6,1.678-4.6,3.747v.65A3.748,3.748,0,0,0,789.472,1896.124Z",
    fill: "#616f77"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3795",
    "data-name": "Group 3795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3792",
    "data-name": "Group 3792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3791",
    "data-name": "Group 3791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3790",
    "data-name": "Group 3790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5610",
    "data-name": "Path 5610",
    d: "M1095.994,1951.732c-11.988-70.258,25.972-142.515,82.578-155.168,9.989,89.238-51.611,155.834-51.611,155.834Z",
    fill: "#c0beed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3794",
    "data-name": "Group 3794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3793",
    "data-name": "Group 3793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5611",
    "data-name": "Path 5611",
    d: "M1126.961,1952.4s61.6-66.6,51.611-155.834c0,0-54.7,91.277-70.216,155.434Z",
    fill: "#e0def9"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3800",
    "data-name": "Group 3800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3797",
    "data-name": "Group 3797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3796",
    "data-name": "Group 3796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5612",
    "data-name": "Path 5612",
    d: "M1123.713,1946.707c2.7-36.254,30.138-47.486,59.489-42.93-1.015,28.782-13.31,48.541-34.41,51.3Z",
    fill: "#c0beed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3799",
    "data-name": "Group 3799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3798",
    "data-name": "Group 3798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5613",
    "data-name": "Path 5613",
    d: "M1148.792,1955.08c21.1-2.762,33.4-22.521,34.41-51.3l-49.227,46.356Z",
    fill: "#e0def9"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3814",
    "data-name": "Group 3814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3803",
    "data-name": "Group 3803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3802",
    "data-name": "Group 3802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3801",
    "data-name": "Group 3801"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5614",
    "data-name": "Path 5614",
    d: "M1084.769,1945.555H968.516a16.425,16.425,0,0,1-16.339-18.1l22.548-219.511a16.854,16.854,0,0,1,16.766-15.131h116.253a16.424,16.424,0,0,1,16.338,18.1l-22.548,219.511A16.853,16.853,0,0,1,1084.769,1945.555Z",
    fill: "#c0beed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3806",
    "data-name": "Group 3806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3805",
    "data-name": "Group 3805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3804",
    "data-name": "Group 3804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5615",
    "data-name": "Path 5615",
    d: "M1074.524,1945.555H958.271a16.424,16.424,0,0,1-16.338-18.1l22.548-219.511a16.853,16.853,0,0,1,16.765-15.131H1097.5a16.424,16.424,0,0,1,16.338,18.1l-22.548,219.511A16.853,16.853,0,0,1,1074.524,1945.555Z",
    fill: "#e1defb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3808",
    "data-name": "Group 3808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3807",
    "data-name": "Group 3807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5616",
    "data-name": "Path 5616",
    d: "M958.271,1942.14A13.01,13.01,0,0,1,945.33,1927.8l22.548-219.511a13.4,13.4,0,0,1,13.368-12.065H1097.5a13.008,13.008,0,0,1,12.941,14.339l-22.548,219.511a13.4,13.4,0,0,1-13.368,12.065Z",
    fill: "#efebf9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3809",
    "data-name": "Group 3809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5617",
    "data-name": "Path 5617",
    d: "M959.948,1920.7a9.595,9.595,0,0,1-9.545-10.575L970,1718.914a10,10,0,0,1,9.971-9h116.253a9.593,9.593,0,0,1,9.544,10.575l-19.6,191.213a10,10,0,0,1-9.972,9Z",
    fill: "#fdfeff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3812",
    "data-name": "Group 3812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3811",
    "data-name": "Group 3811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3810",
    "data-name": "Group 3810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5618",
    "data-name": "Path 5618",
    d: "M1051.938,1706.045H1013.5a2.418,2.418,0,0,1-2.418-2.418h0a2.419,2.419,0,0,1,2.418-2.418h38.434a2.419,2.419,0,0,1,2.418,2.418h0A2.418,2.418,0,0,1,1051.938,1706.045Z",
    fill: "#c0beed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3813",
    "data-name": "Group 3813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5619",
    "data-name": "Path 5619",
    d: "M1057.792,1706.045h0a2.418,2.418,0,0,1-2.418-2.418h0a2.419,2.419,0,0,1,2.418-2.418h0a2.419,2.419,0,0,1,2.418,2.418h0A2.418,2.418,0,0,1,1057.792,1706.045Z",
    fill: "#c0beed"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3820",
    "data-name": "Group 3820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3815",
    "data-name": "Group 3815"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 16.035,
    cy: 14.381,
    rx: 16.035,
    ry: 14.381,
    transform: "translate(975.568 1865.292) rotate(-82.006)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3816",
    "data-name": "Group 3816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5620",
    "data-name": "Path 5620",
    d: "M1008.859,1880.523H973.225a4.454,4.454,0,0,1-4.454-4.454h0a4.454,4.454,0,0,1,4.454-4.454h35.634a4.454,4.454,0,0,1,4.454,4.454h0A4.454,4.454,0,0,1,1008.859,1880.523Z",
    fill: "#fd8ea7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3817",
    "data-name": "Group 3817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5621",
    "data-name": "Path 5621",
    d: "M996.371,1888.955H970.123a2.244,2.244,0,0,1-2.243-2.243h0a2.243,2.243,0,0,1,2.243-2.243h26.248a2.243,2.243,0,0,1,2.243,2.243h0A2.243,2.243,0,0,1,996.371,1888.955Z",
    fill: "#fd8ea7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3818",
    "data-name": "Group 3818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5622",
    "data-name": "Path 5622",
    d: "M1008.207,1898.69H968.883a2.243,2.243,0,0,1-2.243-2.243h0a2.243,2.243,0,0,1,2.243-2.243h39.324a2.243,2.243,0,0,1,2.243,2.243h0A2.243,2.243,0,0,1,1008.207,1898.69Z",
    fill: "#fd8ea7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3819",
    "data-name": "Group 3819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5623",
    "data-name": "Path 5623",
    d: "M1006.966,1908.522H967.642a2.244,2.244,0,0,1-2.243-2.244h0a2.243,2.243,0,0,1,2.243-2.243h39.324a2.243,2.243,0,0,1,2.243,2.243h0A2.244,2.244,0,0,1,1006.966,1908.522Z",
    fill: "#fd8ea7"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3826",
    "data-name": "Group 3826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3821",
    "data-name": "Group 3821"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 16.035,
    cy: 14.381,
    rx: 16.035,
    ry: 14.381,
    transform: "matrix(0.139, -0.99, 0.99, 0.139, 1039.476, 1865.291)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3822",
    "data-name": "Group 3822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5624",
    "data-name": "Path 5624",
    d: "M1072.767,1880.523h-35.634a4.454,4.454,0,0,1-4.454-4.454h0a4.454,4.454,0,0,1,4.454-4.454h35.634a4.454,4.454,0,0,1,4.454,4.454h0A4.454,4.454,0,0,1,1072.767,1880.523Z",
    fill: "#fd8ea7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3823",
    "data-name": "Group 3823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5625",
    "data-name": "Path 5625",
    d: "M1060.279,1888.955h-26.248a2.243,2.243,0,0,1-2.243-2.243h0a2.243,2.243,0,0,1,2.243-2.243h26.248a2.243,2.243,0,0,1,2.243,2.243h0A2.243,2.243,0,0,1,1060.279,1888.955Z",
    fill: "#fd8ea7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3824",
    "data-name": "Group 3824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5626",
    "data-name": "Path 5626",
    d: "M1072.114,1898.69H1032.79a2.243,2.243,0,0,1-2.243-2.243h0a2.243,2.243,0,0,1,2.243-2.243h39.324a2.243,2.243,0,0,1,2.243,2.243h0A2.243,2.243,0,0,1,1072.114,1898.69Z",
    fill: "#fd8ea7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3825",
    "data-name": "Group 3825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5627",
    "data-name": "Path 5627",
    d: "M1070.874,1908.522h-39.325a2.244,2.244,0,0,1-2.243-2.244h0a2.243,2.243,0,0,1,2.243-2.243h39.325a2.244,2.244,0,0,1,2.243,2.243h0A2.244,2.244,0,0,1,1070.874,1908.522Z",
    fill: "#fd8ea7"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3831",
    "data-name": "Group 3831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3828",
    "data-name": "Group 3828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3827",
    "data-name": "Group 3827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5628",
    "data-name": "Path 5628",
    d: "M1089.693,1957.087c4.939-28.948-10.7-58.719-34.024-63.933-4.116,36.768,21.265,64.207,21.265,64.207Z",
    fill: "#e0def9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3830",
    "data-name": "Group 3830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3829",
    "data-name": "Group 3829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5629",
    "data-name": "Path 5629",
    d: "M1076.934,1957.361s-25.381-27.439-21.265-64.207c0,0,22.538,37.608,28.931,64.042Z",
    fill: "#c0beed"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3843",
    "data-name": "Group 3843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3832",
    "data-name": "Group 3832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5630",
    "data-name": "Path 5630",
    d: "M904.44,1823.314a9.595,9.595,0,0,1-9.545-10.575l7.816-71.052a10,10,0,0,1,9.971-9h155.281a9.6,9.6,0,0,1,9.544,10.575l-7.816,71.053a10,10,0,0,1-9.971,9Z",
    fill: "#fe496e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3834",
    "data-name": "Group 3834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3833",
    "data-name": "Group 3833"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5631",
    "data-name": "Path 5631",
    d: "M900.24,1816.442a9.593,9.593,0,0,1-9.544-10.575l7.815-71.053a10,10,0,0,1,9.972-9h155.28a9.593,9.593,0,0,1,9.544,10.575l-7.816,71.052a10,10,0,0,1-9.971,9Z",
    fill: "#ff698e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3835",
    "data-name": "Group 3835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5632",
    "data-name": "Path 5632",
    d: "M1065.491,1807.443l3.174-28.847-13.673-15.25-24.689,25.962s14.763,14.507,17.562,16.544c1.194.868,7.66,4.187,14.686,7.71A9.989,9.989,0,0,0,1065.491,1807.443Z",
    fill: "#fe8da7"
  })), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 140,
    height: 83,
    transform: "translate(927 1734.332)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAABTCAYAAABNqO/EAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQgSURBVHhe7Z0NbtswDEbbnHLn2EF2jp1yWZlFneJIFiVTIil+DzAWFIMrk08f1aA/n/f7/SMa91+/H099+/nj899HAJfb898w/PmS5fny5TXgEUqYkiCQpo8QI+koBc2h41NjPPHYPmFKCVLaIkgaHlsnTE2CUsLkIG3qbJswZ4nR2iJImzpbCtNqOCc+IE2ZrUYSt8mtkZSD8fTKNgkzQxYCSfPKFsLMbiqk+Y/7kdTbzN6EORJ9RLlOGI2dHz1tXCbMlaZdTZhE1KRxlzBWdnjUpHEljLUmRZTGjTDUHGszgNYTTRrzZ5jUEKmzh9R9iPxeUc40poXJd69EoyVlIUr3210csyNJWpYZ0JqOduw+okwK473oO0tjTphjsa2mS4tdpTFzhqkVWFKYGfK17rnbmcZEwqyQRYvdkkY9Yc4KKi3MLAG5990hbVQTZqUsFtghbVQSplU47STopfe+npNmecJo7TJLieU5aZYKwymUpcbOxKs0y4TxvKta0IONzBiPNVlyhuEWZma6zE6u0fsn0T6dnGumCtO7gyIKQ3iSZtpIsiSLF+j31jxfmmWKMDufV2aQF8u6NOLCjMiCdPEjjagwVpNlhZB0f8kDiFVpRA69V0RZ0cxVCSbxeUrSWToMX04YD+cV8wvMKK3VUtpcEuaqLCt3vnesSDMsjIdkSdBCSZp0WadWWAvSdJ9hpERZlS6JmijSa5B8rtqaNc80XQkjafhKWc6gyqfLC5pJw04YWqTkztF44h4pRtcn/WytNa9OG1bCSMpCaMjSC3Uhv7Ro1Wp12jSFkZbFKxbkqbFSmupImikKFV1LQumGr3oOzrpXjKdiwiBV+FCH0jUTTj9WJM2bMJBlnFye2QLVmC3Ny0ha+WYcFVRLTI1mSj1rz9pnjKiHMBqpEk2YnKvPrSnNjVJFq3FRoQ7m10ykR1TXO72S0FPMLlYNaxukV57e9UtKc9NqGijDlUdLmhvNOEhjE648XCSkURtJBK1eS1axjF5ELk+q2cgzPL7AuSCOqjBgnFycEUalgTABIDNK18j7bg9hop5juqu1Ib1Jo54wtNqIsq7krL69SYORFITWpuQmTXhhuvLYOZykaaXNtzCa5xhaIcbSGjh1PpMGIykgV6SBMF+cZvCmcKQpnWtehMFYikWr3tSTY9IgYYLTO57evgmcYuj1I+ugxWt9biJywnHrbiphaNEYSzpw6k7/500YfLtDXFp9pw2NM0yG5jj0QDFhdoEebuSKzlkNaPqoCnNsVlps6eO9FxjnrH5FYcik58u3RkhewC61/lQTBk0Fef/Taxx6AYv0BUE9YbKxBEACCQOq5G8zpL8iB2FAFxAGNMn/RuWpMDjHxIaaf/yDpkgYUKUUGM1fuzr6E3LAJ62pAmFAx9Hj4+MvBhQRl8Ff0OMAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5633",
    "data-name": "Path 5633",
    d: "M966.587,1816.445H900.24a9.608,9.608,0,0,1-9.546-10.576l1.586-14.405,27.3-27.1Z",
    fill: "#fe8da7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3840",
    "data-name": "Group 3840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3836",
    "data-name": "Group 3836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5634",
    "data-name": "Path 5634",
    d: "M942.24,1793.165a4.665,4.665,0,0,1-4.641-5.143l3.8-34.553a4.861,4.861,0,0,1,4.849-4.377h75.514a4.665,4.665,0,0,1,4.641,5.143l-3.8,34.553a4.862,4.862,0,0,1-4.849,4.377Z",
    fill: "#ffc5d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3837",
    "data-name": "Group 3837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5635",
    "data-name": "Path 5635",
    d: "M993.047,1764.682H954.1a5.44,5.44,0,0,1-5.44-5.441h0a5.44,5.44,0,0,1,5.44-5.44h38.943a5.441,5.441,0,0,1,5.44,5.44h0A5.441,5.441,0,0,1,993.047,1764.682Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3838",
    "data-name": "Group 3838"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 42.76,
    height: 4.2,
    rx: 2.1,
    transform: "translate(944.464 1769.645)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3839",
    "data-name": "Group 3839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5636",
    "data-name": "Path 5636",
    d: "M1008.318,1783.263H945.291a2.1,2.1,0,0,1-2.1-2.1h0a2.1,2.1,0,0,1,2.1-2.1h63.027a2.1,2.1,0,0,1,2.1,2.1h0A2.1,2.1,0,0,1,1008.318,1783.263Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3842",
    "data-name": "Group 3842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 7.636,
    cy: 7.636,
    r: 7.636,
    transform: "translate(1034.885 1733.312)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3921",
    "data-name": "Group 3921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3860",
    "data-name": "Group 3860"
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3846",
    "data-name": "Group 3846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3844",
    "data-name": "Group 3844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5637",
    "data-name": "Path 5637",
    d: "M1119.953,1938.119a15.884,15.884,0,0,1-1.219-7.607c.19-1.381.427-3.123.693-5.118.132-.993.271-2.048.415-3.153l-6.612,1.771c.113,1.19.218,2.306.315,3.326a23.881,23.881,0,0,1-.249,6.517,6.577,6.577,0,0,1-.4,1.5c-.525,1.065-4.321,4.746-6.055,7.919-.163.386-4.084,1.006-3.5,1.905.357.2,7.2.733,7.961,0s2.586-2.572,4.622-2.984a29.485,29.485,0,0,1,.127,3.321l2.961.013s.344-2.928.475-3.812S1120.634,1939.481,1119.953,1938.119Z",
    fill: "#ff8762"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3845",
    "data-name": "Group 3845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5638",
    "data-name": "Path 5638",
    d: "M1106.821,1943.306a10.237,10.237,0,0,0,3.071.207c.64-.281,4.864-5.522,9.5-6.813a9.4,9.4,0,0,0,.557,1.419c.681,1.362-.327,2.708-.458,3.591s-.475,3.812-.475,3.812l-2.961-.013a29.459,29.459,0,0,0-.127-3.32c-2.036.411-3.856,2.246-4.622,2.983s-7.6.2-7.961,0C1102.778,1944.3,1106.459,1943.719,1106.821,1943.306Z",
    fill: "#2b1710"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3849",
    "data-name": "Group 3849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3847",
    "data-name": "Group 3847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5639",
    "data-name": "Path 5639",
    d: "M1144.107,1938.119a15.906,15.906,0,0,1-1.219-7.607c.191-1.381.428-3.123.693-5.118.133-.993.271-2.048.415-3.153l-6.612,1.771c.113,1.19.219,2.306.316,3.326a23.959,23.959,0,0,1-.249,6.517,6.636,6.636,0,0,1-.4,1.5c-.526,1.065-4.322,4.746-6.056,7.919-.163.386-4.084,1.006-3.495,1.905.356.2,7.195.733,7.961,0s2.585-2.572,4.621-2.984a29.259,29.259,0,0,1,.128,3.321l2.961.013s.343-2.928.474-3.812S1144.788,1939.481,1144.107,1938.119Z",
    fill: "#ff8762"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3848",
    "data-name": "Group 3848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5640",
    "data-name": "Path 5640",
    d: "M1130.975,1943.306a10.241,10.241,0,0,0,3.071.207c.641-.281,4.864-5.522,9.5-6.813a9.475,9.475,0,0,0,.557,1.419c.681,1.362-.327,2.708-.458,3.591s-.474,3.812-.474,3.812l-2.961-.013a29.234,29.234,0,0,0-.128-3.32c-2.036.411-3.856,2.246-4.621,2.983s-7.6.2-7.961,0C1126.932,1944.3,1130.614,1943.719,1130.975,1943.306Z",
    fill: "#2b1710"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3851",
    "data-name": "Group 3851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3850",
    "data-name": "Group 3850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5641",
    "data-name": "Path 5641",
    d: "M1116.621,1819.076c-6.71,6.758-10.113,19.612-9.546,28.875s.378,85.695.378,85.695h16.887l1.072-87.964,5.734,87.964h17.9s-1.26-79.9-3.025-92.753a45.532,45.532,0,0,0-9.688-21.817Z",
    fill: "url(#linear-gradient-3)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3853",
    "data-name": "Group 3853",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3852",
    "data-name": "Group 3852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5642",
    "data-name": "Path 5642",
    d: "M1125.222,1843.818a.122.122,0,0,1-.12-.108l-.935-8.608a6.587,6.587,0,0,1-1.758-.571c-.543-.407.133-13.862.141-14a.121.121,0,1,1,.241.014c-.22,3.748-.528,13.306-.223,13.8a7.121,7.121,0,0,0,1.733.531.12.12,0,0,1,.1.106l.946,8.695a.121.121,0,0,1-.107.133Z",
    fill: "#bfbfbf"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3855",
    "data-name": "Group 3855",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3854",
    "data-name": "Group 3854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5643",
    "data-name": "Path 5643",
    d: "M1145.827,1929.64a.121.121,0,0,1-.121-.117c-.02-.677-2.087-67.788-2.834-75.259l-.017-.162c-.741-7.417-2.478-24.788-8.092-33.116a.121.121,0,0,1,.2-.135c5.648,8.378,7.389,25.791,8.133,33.227l.016.162c.748,7.479,2.815,74.6,2.836,75.275a.121.121,0,0,1-.117.125Z",
    fill: "#bfbfbf"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3857",
    "data-name": "Group 3857",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3856",
    "data-name": "Group 3856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5644",
    "data-name": "Path 5644",
    d: "M1148.19,1930.4h-16.918a.121.121,0,0,1,0-.242h16.918a.121.121,0,1,1,0,.242Z",
    fill: "#bfbfbf"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3859",
    "data-name": "Group 3859",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3858",
    "data-name": "Group 3858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5645",
    "data-name": "Path 5645",
    d: "M1123.616,1930.4h-15.69a.121.121,0,0,1,0-.242h15.69a.121.121,0,0,1,0,.242Z",
    fill: "#bfbfbf"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3862",
    "data-name": "Group 3862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3861",
    "data-name": "Group 3861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5646",
    "data-name": "Path 5646",
    d: "M1130.469,1786.784a.12.12,0,0,1-.088-.107.122.122,0,0,1,.072-.118,7.249,7.249,0,0,0,4.021-4.675,15.05,15.05,0,0,0-.517-9.263,4.947,4.947,0,0,0-1.639-1.378.12.12,0,1,1,.109-.213,4.989,4.989,0,0,1,1.3.966,21.535,21.535,0,0,0-1.738-3.511.12.12,0,0,1,.2-.125,21.727,21.727,0,0,1,1.975,4.143,8.543,8.543,0,0,1,1.439,3.094c.981,3.757.257,8.787-1.685,11.7a.119.119,0,0,1-.094.053h-.073A13.047,13.047,0,0,1,1130.469,1786.784Zm4.233-4.828a7.526,7.526,0,0,1-3.851,4.683,12.4,12.4,0,0,0,2.907.472,15.781,15.781,0,0,0,1.618-11.453,9.121,9.121,0,0,0-.938-2.33A14.866,14.866,0,0,1,1134.7,1781.956Z",
    fill: "#2b1710"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3864",
    "data-name": "Group 3864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3863",
    "data-name": "Group 3863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5647",
    "data-name": "Path 5647",
    d: "M1126.43,1764.94a.119.119,0,0,0,.074-.214c-3.541-2.748-10.1-5.574-13.678-2.1a.12.12,0,0,0,.167.172c3.464-3.372,9.89-.583,13.364,2.114A.119.119,0,0,0,1126.43,1764.94Z",
    fill: "#2b1710"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3866",
    "data-name": "Group 3866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3865",
    "data-name": "Group 3865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5648",
    "data-name": "Path 5648",
    d: "M1111.055,1773.436a3.064,3.064,0,0,0,2.458-.957c.885-1.022.893-2.776.019-4.576a.119.119,0,0,0-.215.1c.831,1.713.837,3.367.015,4.315-.6.694-1.91,1.332-4.737.432a19.493,19.493,0,0,1-5.649-3.341c-2.638-1.991-5.129-3.872-8.578-3.448a.119.119,0,0,0,.029.237c3.353-.412,5.807,1.44,8.405,3.4a19.671,19.671,0,0,0,5.72,3.377A8.426,8.426,0,0,0,1111.055,1773.436Z",
    fill: "#2b1710"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3867",
    "data-name": "Group 3867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5649",
    "data-name": "Path 5649",
    d: "M1130.08,1786.248c7.3-5.146,6.456-21.334-3.182-21.334-6.737-4.4-14.6-2.9-14.316.936s3.743,3.649,2.62,6.456-7.018,2.807-15.065-2.713-13.661-.936-13.567,1.4c-4.3.094-4.585,3.93-4.211,4.585-3.088,6.176.936,13.661,4.3,14.971-2.9,4.024,4.772,10.48,10.761,10.854s17.217.655,18.62-.842S1130.08,1786.248,1130.08,1786.248Z",
    fill: "#2b1710"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3877",
    "data-name": "Group 3877"
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3868",
    "data-name": "Group 3868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5650",
    "data-name": "Path 5650",
    d: "M1117.74,1802.253l-5.97-6.414c-11.479,5.157-22.669,5.234-25.223-7.848,1.307-2.445.718-5.992.911-6.94s-.98-.777-1.5,1.087-.418,2.8-1.308,1.729-1.329-10.28-3.759-7.557c-1.54.051-1.9,2.079-1.9,2.079-.614.111-1.037,3.065-1.037,3.065-.553-.868-.789-.188-.441,1.946a13.436,13.436,0,0,0,3.022,5.94c1.08,3.141,2.939,15.559,16.633,18.967C1108.361,1811.094,1117.74,1802.253,1117.74,1802.253Z",
    fill: "#fbc585"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 7,
    height: 8,
    transform: "translate(1077 1775.332)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABASURBVBhXY/z//z8DDPw6mA7nsNnPZGSCslEkYAAuiQ5AisGS2HSBAE6dIMCESxcIYNUJcimKa0EAJgjhMTAAAEV8Fw3mUGrlAAAAAElFTkSuQmCC"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3869",
    "data-name": "Group 3869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5651",
    "data-name": "Path 5651",
    d: "M1094.6,1803.269c2.694.473,4.59,2.489,4.237,4.5a2.809,2.809,0,0,1-.285.819c-.459-.075-.921-.168-1.388-.285a21.394,21.394,0,0,1-7.556-3.451A5.091,5.091,0,0,1,1094.6,1803.269Z",
    fill: "#f9c066"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3871",
    "data-name": "Group 3871",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3870",
    "data-name": "Group 3870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5652",
    "data-name": "Path 5652",
    d: "M1081.563,1782.91a.109.109,0,0,0,.109.031.111.111,0,0,0,.078-.135,21.155,21.155,0,0,1-.642-6.209.11.11,0,0,0-.218-.031,21.435,21.435,0,0,0,.647,6.3A.118.118,0,0,0,1081.563,1782.91Z",
    fill: "#e0b3a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3873",
    "data-name": "Group 3873",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3872",
    "data-name": "Group 3872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5653",
    "data-name": "Path 5653",
    d: "M1079.323,1783.348a.109.109,0,0,0,.1.032.11.11,0,0,0,.086-.13,15,15,0,0,1-.18-4.7.11.11,0,0,0-.217-.038,15.293,15.293,0,0,0,.181,4.785A.113.113,0,0,0,1079.323,1783.348Z",
    fill: "#e0b3a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3875",
    "data-name": "Group 3875",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3874",
    "data-name": "Group 3874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5654",
    "data-name": "Path 5654",
    d: "M1078.289,1783.722a.113.113,0,0,0,.108.032.111.111,0,0,0,.08-.134,9.487,9.487,0,0,1-.3-1.838.11.11,0,1,0-.22-.008,9.57,9.57,0,0,0,.3,1.9A.113.113,0,0,0,1078.289,1783.722Z",
    fill: "#e0b3a8"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3876",
    "data-name": "Group 3876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5655",
    "data-name": "Path 5655",
    d: "M1084.707,1784.866a4.673,4.673,0,0,0-1.468,2.648c-3.254-2.552-4.531-2.648-4.531-2.648,3.414.223,4.148,1.4,4.148,1.4C1084.132,1784.962,1084.707,1784.866,1084.707,1784.866Z",
    fill: "#f9c066"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3878",
    "data-name": "Group 3878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5656",
    "data-name": "Path 5656",
    d: "M1130.315,1784.449c12.209,5.916,12.9,18.7,12.9,18.7l-1.747.062-6.425,11.1,3.119,6.363c-8.484,2.994-25.434,2.831-25.434,2.831l.29-9.838a12.434,12.434,0,0,0-.923-5.092c-1.1-2.669-2.635-6.725-2.108-7.314.795-.889,3.161-6.475,3.161-6.475l-2.808.016c3.322-6.784,7.139-9.981,9.114-10.628a11.972,11.972,0,0,1,4.454.007Z",
    fill: "url(#linear-gradient-4)"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3879",
    "data-name": "Group 3879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5657",
    "data-name": "Path 5657",
    d: "M1130.814,1784.449c0-.137-1.989-.583-2.708-1.851s-1.063-4.491-.789-8.811c-1.68.446-2.263-.891-2.3-3.188s-1.131-5.966-5.588-5.383c-1.68,2.057-2.571,3.36-2.434,6.034s-.16,4.571.16,5.851a4.759,4.759,0,0,0,4.845,3.543c.274,1.645.491,3.259-2.054,3.538C1122.521,1788.342,1130.814,1784.449,1130.814,1784.449Z",
    fill: "#fbc585"
  }))), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 3,
    height: 3,
    transform: "translate(1117 1773.332)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAsSURBVBhXY/zflvj/Hy8jw38eRgYmBiAAMf4JMTIw/v//n+HXwfT/DAwMDAAKkA09joPhPQAAAABJRU5ErkJggg=="
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3881",
    "data-name": "Group 3881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3880",
    "data-name": "Group 3880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5658",
    "data-name": "Path 5658",
    d: "M1118.876,1775.543a.085.085,0,0,0,.068-.033.087.087,0,0,0-.014-.123,8.774,8.774,0,0,1-1.068-.958,2.611,2.611,0,0,1,.375-.022,2.124,2.124,0,0,0,.888-.132c.468-.264.016-2.244-.4-3.175a.086.086,0,0,0-.115-.044.088.088,0,0,0-.045.115c.481,1.082.754,2.792.472,2.951a2.088,2.088,0,0,1-.8.11c-.353.006-.566.01-.566.172s.627.7,1.153,1.12A.088.088,0,0,0,1118.876,1775.543Z",
    fill: "#2b1710"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3882",
    "data-name": "Group 3882"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 0.531,
    cy: 0.943,
    rx: 0.531,
    ry: 0.943,
    transform: "translate(1121.539 1771.661)",
    fill: "#2b1710"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3884",
    "data-name": "Group 3884",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3883",
    "data-name": "Group 3883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5659",
    "data-name": "Path 5659",
    d: "M1122.191,1773.867c.182,0,.585-.079.716-.746a.043.043,0,0,0-.034-.051.044.044,0,0,0-.052.034c-.127.649-.513.687-.673.674a.042.042,0,0,0-.047.04.043.043,0,0,0,.04.047Z",
    fill: "#e0b3a8"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3885",
    "data-name": "Group 3885"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 0.531,
    cy: 0.943,
    rx: 0.531,
    ry: 0.943,
    transform: "translate(1117.516 1771.776)",
    fill: "#2b1710"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3887",
    "data-name": "Group 3887",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3886",
    "data-name": "Group 3886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5660",
    "data-name": "Path 5660",
    d: "M1118.168,1773.981c1.513,0,.586-.078.717-.746a.045.045,0,0,0-.035-.051.043.043,0,0,0-.051.035c-.128.648-.513.686-.674.673a.043.043,0,0,0-.047.04.044.044,0,0,0,.04.047Z",
    fill: "#e0b3a8"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3888",
    "data-name": "Group 3888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5661",
    "data-name": "Path 5661",
    d: "M1121.783,1776.824c-2.035-.628-3.995-.606-3.826-.083C1117.839,1778.014,1120.017,1779.357,1121.783,1776.824Z",
    fill: "#f9c066"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3890",
    "data-name": "Group 3890",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3889",
    "data-name": "Group 3889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5662",
    "data-name": "Path 5662",
    d: "M1119.743,1779.381a2.17,2.17,0,0,1-.752-.129.07.07,0,0,1-.042-.09.071.071,0,0,1,.091-.042,2.157,2.157,0,0,0,1.123.08.07.07,0,1,1,.033.136A2.074,2.074,0,0,1,1119.743,1779.381Z",
    fill: "#2b1710"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3891",
    "data-name": "Group 3891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5663",
    "data-name": "Path 5663",
    d: "M1118.933,1765.216c.254,3.726,5.458,4.266,6.4,4.064S1123.815,1763.586,1118.933,1765.216Z",
    fill: "#2b1710"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3892",
    "data-name": "Group 3892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5664",
    "data-name": "Path 5664",
    d: "M1123.483,1775.468a1.137,1.137,0,1,1-.972-1.23A1.109,1.109,0,0,1,1123.483,1775.468Z",
    fill: "#f9c066"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3896",
    "data-name": "Group 3896"
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3893",
    "data-name": "Group 3893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5665",
    "data-name": "Path 5665",
    d: "M1126.3,1774.865a1.251,1.251,0,1,0,1.007-1.455A1.251,1.251,0,0,0,1126.3,1774.865Z",
    fill: "#f9c066"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3895",
    "data-name": "Group 3895",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3894",
    "data-name": "Group 3894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5666",
    "data-name": "Path 5666",
    d: "M1126.657,1774.8a.9.9,0,0,0,.5.648.051.051,0,0,0,.032,0,.052.052,0,0,0,.013-.1.787.787,0,0,1-.428-.523.533.533,0,1,0,.336-.836c-.012,0-.022.007-.033.009a.784.784,0,0,1,.978.049.055.055,0,0,0,.075,0,.054.054,0,0,0-.005-.075.891.891,0,0,0-1.467.827Zm.126-.2a.428.428,0,1,1,.5.345A.428.428,0,0,1,1126.783,1774.6Z",
    fill: "#e0b3a8"
  }))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3897",
    "data-name": "Group 3897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5667",
    "data-name": "Path 5667",
    d: "M1121.781,1780.531c3.349-1.138,4.334-4.619,4.378-4.553C1125.633,1781.6,1122.328,1783.486,1121.781,1780.531Z",
    fill: "#f9c066"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3898",
    "data-name": "Group 3898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5668",
    "data-name": "Path 5668",
    d: "M1121.439,1770.809a3.44,3.44,0,0,1,1.571.321.188.188,0,0,0,.23-.284c-.858-1.17-2.083-1.121-1.995-.21A.193.193,0,0,0,1121.439,1770.809Z",
    fill: "#2b1710"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3899",
    "data-name": "Group 3899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5669",
    "data-name": "Path 5669",
    d: "M1118.075,1770.792a2.782,2.782,0,0,0-1.255.3.145.145,0,0,1-.176-.226c.709-.974,1.681-.963,1.589-.218A.166.166,0,0,1,1118.075,1770.792Z",
    fill: "#2b1710"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3901",
    "data-name": "Group 3901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3900",
    "data-name": "Group 3900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5670",
    "data-name": "Path 5670",
    d: "M1119.484,1777.313a5.963,5.963,0,0,0,2.563-.511.084.084,0,1,0-.085-.145,6.163,6.163,0,0,1-3.541.374.939.939,0,0,1-.59-.344.085.085,0,0,0-.115-.03.084.084,0,0,0-.03.115,1.075,1.075,0,0,0,.693.421A4.513,4.513,0,0,0,1119.484,1777.313Z",
    fill: "#2b1710"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3903",
    "data-name": "Group 3903",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3902",
    "data-name": "Group 3902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5671",
    "data-name": "Path 5671",
    d: "M1113.83,1794.1a.121.121,0,0,0,.1-.059,47.869,47.869,0,0,1,3.421-5.039.12.12,0,0,0-.187-.149,47.935,47.935,0,0,0-3.44,5.067.118.118,0,0,0,.042.163A.122.122,0,0,0,1113.83,1794.1Z",
    fill: "#bfbfbf"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3905",
    "data-name": "Group 3905",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3904",
    "data-name": "Group 3904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5672",
    "data-name": "Path 5672",
    d: "M1129.986,1799.155a.119.119,0,0,0,.12-.119c0-6.954,2.138-9.617,3.931-10.625a.12.12,0,0,0-.117-.209c-1.849,1.04-4.053,3.764-4.053,10.834A.119.119,0,0,0,1129.986,1799.155Z",
    fill: "#bfbfbf"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3907",
    "data-name": "Group 3907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3906",
    "data-name": "Group 3906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5673",
    "data-name": "Path 5673",
    d: "M1124.424,1770.111a8.921,8.921,0,0,0,2.271-.309.12.12,0,0,0-.061-.232c-2.478.657-4.741.228-6.052-1.147a2.978,2.978,0,0,1-.775-3.005.119.119,0,1,0-.227-.072,3.21,3.21,0,0,0,.829,3.243A5.431,5.431,0,0,0,1124.424,1770.111Z",
    fill: "#2b1710"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3920",
    "data-name": "Group 3920"
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3909",
    "data-name": "Group 3909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3908",
    "data-name": "Group 3908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5674",
    "data-name": "Path 5674",
    d: "M1141.51,1803.234a24.653,24.653,0,0,0-10.347-3.937c-.367,9.8-1.649,14.742-5.22,14.376s-7.737-11.171-8.287-14.376c-.457-4.029-.812-6.4.149-8.253s-1.133-2.541-2.026-.206-.95,3.961-2.289,2.827a16.694,16.694,0,0,0-7.36-3.342c-3.88-.893-3.227.721-2.163,1.374-2.438-.275-2.472.309-1.786,1.03-.618.343-.446,1.1.447,1.682-.515.515.549,2.061,2.3,2.679s5.907,2.506,7.28,5.94,3.4,15.022,7.646,19.344c3.983,4.052,13.392,3.708,17.718-2.61S1141.51,1803.234,1141.51,1803.234Z",
    fill: "#fbc585"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3911",
    "data-name": "Group 3911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3910",
    "data-name": "Group 3910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5675",
    "data-name": "Path 5675",
    d: "M1132.583,1823.877c-4.027,1.8-8.8,1.441-11.762-.686C1122.661,1817.752,1132.327,1818.964,1132.583,1823.877Z",
    fill: "#f9c066"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3913",
    "data-name": "Group 3913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3912",
    "data-name": "Group 3912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5676",
    "data-name": "Path 5676",
    d: "M1131.163,1799.3a24.653,24.653,0,0,1,10.347,3.937,36.5,36.5,0,0,1-.153,4.149c-2.219-4.161-7.527-7.249-10.2-7.844C1131.156,1799.458,1131.16,1799.379,1131.163,1799.3Z",
    fill: "#f9c066"
  })))), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 9,
    height: 9,
    transform: "translate(1101 1789.332)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABISURBVChTY/z//z8DCPw6mA5hQAGb/UxGKJMBpyJkwPjzQBpOSRhgQjYWF2CC0jgByBCCikAArAiXlTBx4k0CAZAu7CYyMAAA/ikVg2RVa0UAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3915",
    "data-name": "Group 3915",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3914",
    "data-name": "Group 3914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5677",
    "data-name": "Path 5677",
    d: "M1109.324,1794.028a.086.086,0,0,0,.075-.043.087.087,0,0,0-.03-.12,25.756,25.756,0,0,0-4.78-2.115.088.088,0,0,0-.053.168,25.641,25.641,0,0,1,4.743,2.1A.08.08,0,0,0,1109.324,1794.028Z",
    fill: "#e0b3a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3917",
    "data-name": "Group 3917",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3916",
    "data-name": "Group 3916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5678",
    "data-name": "Path 5678",
    d: "M1108,1795.584a.087.087,0,0,0,.06-.151,26.719,26.719,0,0,0-5.552-2.584.087.087,0,0,0-.109.059.088.088,0,0,0,.059.109,26.591,26.591,0,0,1,5.482,2.544A.087.087,0,0,0,1108,1795.584Z",
    fill: "#e0b3a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3919",
    "data-name": "Group 3919",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3918",
    "data-name": "Group 3918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5679",
    "data-name": "Path 5679",
    d: "M1106.371,1796.34a.088.088,0,0,0,.039-.166c-.014-.007-1.4-.7-3.252-1.581a.088.088,0,0,0-.076.159c1.855.882,3.236,1.572,3.249,1.579A.093.093,0,0,0,1106.371,1796.34Z",
    fill: "#e0b3a8"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3958",
    "data-name": "Group 3958"
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3922",
    "data-name": "Group 3922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5680",
    "data-name": "Path 5680",
    d: "M768.163,1881.432s8.756,2.918,10.776,6.286-15.491,41.758-15.491,41.758L751.1,1879.411Z",
    fill: "url(#linear-gradient-5)"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3923",
    "data-name": "Group 3923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5681",
    "data-name": "Path 5681",
    d: "M757.237,1934.041c-1.647,4.715-1.347,9.43-.674,10.777h26.043c-.9-2.1-8.831-6.137-12.423-7.783a8.076,8.076,0,0,1-4.415-4.865Z",
    fill: "#fbc585"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3924",
    "data-name": "Group 3924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5682",
    "data-name": "Path 5682",
    d: "M716.676,1892.133c-.038.973,1.871,4.9,9.5,4.9s21.777.561,21.777.561,7.409,36.483,7.746,36.6c7.408,1.347,11.225-.337,11.225-.337s-1.8-40.523-2.357-46.248a8.988,8.988,0,0,0-5.052-7.521l-34.013.112S716.377,1885.323,716.676,1892.133Z",
    fill: "url(#linear-gradient-6)"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3925",
    "data-name": "Group 3925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5683",
    "data-name": "Path 5683",
    d: "M761.727,1850.674l3.218,6.436-10.7.711s-.636-4.265-.636-4.415S761.727,1850.674,761.727,1850.674Z",
    fill: "#fbc585"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3926",
    "data-name": "Group 3926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5684",
    "data-name": "Path 5684",
    d: "M728.462,1830.506c-9.017,3.555-16.2,11.487-21.29,22.339.6.6.9.6.9.6s6.885,19.009,6.885,20.58c-.3,3.143,1.721,18.559,1.721,18.11,5.388-7.558,14.443-12.273,16.539-12.273s19.981-14.144,19.981-14.144l.6-10.327c6.436-1.122,8.906-4.64,8.906-4.64-.075-.224-8.681-13.4-11.226-14.518s-5.724-2.432-5.724-2.432Z",
    fill: "url(#linear-gradient-7)"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3927",
    "data-name": "Group 3927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5685",
    "data-name": "Path 5685",
    d: "M708.07,1853.443a37.766,37.766,0,0,0,12.871,4.416l.075,7.483c7.858,2.844,17.811,6.511,20.73,6.586s-1.871,6.66-1.871,6.66-24.771.225-29.56-1.347c-3.068-.15-3.443-2.245-3.068-3.592C706.274,1867.512,708.07,1853.443,708.07,1853.443Z",
    fill: "#fbc585"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3928",
    "data-name": "Group 3928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5686",
    "data-name": "Path 5686",
    d: "M772.616,1854.865H739.538l-5.737,24.4h33.077Z",
    fill: "#56568c"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3929",
    "data-name": "Group 3929"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5687",
    "data-name": "Path 5687",
    d: "M732.522,1815.932c-.954-6.735,3.536-8.307,5.557-7.858,4.1-1.066,7.745.674,8.812.674s.112,2.189,0,2.582c.786,2.694-.113,5.837-.449,7.577s.28,5.219.729,6.847.187,4.3-4.565,4.9c-7.053,1.609-7.951,1.216-7.951,1.048s-.673-7.578-.673-7.578l-.084-3.761Z",
    fill: "#2b1710"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3930",
    "data-name": "Group 3930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5688",
    "data-name": "Path 5688",
    d: "M736.358,1828.972a7.263,7.263,0,0,0,6.248,1.684,11.673,11.673,0,0,0,3.144,3.143c-3.218,4.9-12.236,3.929-17.288-3.293,4.75-3.115,5.657-11.037,5.657-11.037S733.681,1826.258,736.358,1828.972Z",
    fill: "#fbc585"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3931",
    "data-name": "Group 3931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5689",
    "data-name": "Path 5689",
    d: "M736.133,1813.406c-.486,4.041-.86,8.232,1.31,8.981s5.388-.861,8.381.037c.038-3.106.487-6.848.487-6.848a12.23,12.23,0,0,0-1.721-3.03,5.555,5.555,0,0,1-3.368-1.647c-.486,1.235-1.422,1.16-2.657,1.123S736.133,1813.406,736.133,1813.406Z",
    fill: "#fbc585"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3932",
    "data-name": "Group 3932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5690",
    "data-name": "Path 5690",
    d: "M739.314,1823.144a30.359,30.359,0,0,1,5.921,0c-.084,1.544-.842,3.761-2.891,3.424S739.314,1823.144,739.314,1823.144Z",
    fill: "#fbc585"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3933",
    "data-name": "Group 3933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5691",
    "data-name": "Path 5691",
    d: "M741.025,1818.724c0,.566-.27,1.025-.6,1.025s-.6-.459-.6-1.025.27-1.024.6-1.024S741.025,1818.159,741.025,1818.724Z",
    fill: "#2b1710"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3934",
    "data-name": "Group 3934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5692",
    "data-name": "Path 5692",
    d: "M745.544,1818.64c0,.566-.27,1.024-.6,1.024s-.6-.458-.6-1.024.27-1.024.6-1.024S745.544,1818.074,745.544,1818.64Z",
    fill: "#2b1710"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3935",
    "data-name": "Group 3935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5693",
    "data-name": "Path 5693",
    d: "M742.625,1821.688a.144.144,0,0,1-.008-.287,16.283,16.283,0,0,0,2.329-.249c-.065-.094-.214-.27-.339-.418a6.529,6.529,0,0,1-.9-1.26,3.562,3.562,0,0,1-.156-1.972c.022-.211.044-.429.057-.652a.144.144,0,0,1,.287.016c-.014.228-.036.45-.059.666a3.3,3.3,0,0,0,.129,1.818,6.4,6.4,0,0,0,.865,1.2c.313.37.44.526.44.659s0,.332-2.633.48Z",
    fill: "#2b1710"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3936",
    "data-name": "Group 3936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5694",
    "data-name": "Path 5694",
    d: "M742.1,1824.3a7.822,7.822,0,0,1-2.207-.264.143.143,0,1,1,.085-.274,11.271,11.271,0,0,0,4.645.005.143.143,0,0,1,.11.264A10.988,10.988,0,0,1,742.1,1824.3Z",
    fill: "#2b1710"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3938",
    "data-name": "Group 3938",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3937",
    "data-name": "Group 3937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5695",
    "data-name": "Path 5695",
    d: "M741.9,1825.87a.144.144,0,0,1-.05-.278c1.235-.46,1.752-.19,1.807-.158a.143.143,0,0,1-.145.247s-.454-.233-1.562.18A.143.143,0,0,1,741.9,1825.87Z",
    fill: "#e0b3a8"
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3939",
    "data-name": "Group 3939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5696",
    "data-name": "Path 5696",
    d: "M737.321,1816.549c2.049-.084,4.574-.056,4.659-.056C741.671,1815.623,739.314,1814.136,737.321,1816.549Z",
    fill: "#2b1710"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3940",
    "data-name": "Group 3940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5697",
    "data-name": "Path 5697",
    d: "M744.141,1816.521a4.347,4.347,0,0,1,2.1.281C745.572,1815.23,744.112,1815.623,744.141,1816.521Z",
    fill: "#2b1710"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3941",
    "data-name": "Group 3941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5698",
    "data-name": "Path 5698",
    d: "M774.05,1854.865H740.972l-5.737,24.4h33.077Z",
    fill: "url(#linear-gradient-8)"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3942",
    "data-name": "Group 3942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5699",
    "data-name": "Path 5699",
    d: "M753.969,1868.9h-2.32a3.667,3.667,0,0,1,3.667-3.667h2.32A3.667,3.667,0,0,1,753.969,1868.9Z",
    fill: "#c4c3f4"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3943",
    "data-name": "Group 3943"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 45.799,
    height: 2.17,
    transform: "translate(722.363 1879.262)",
    fill: "#56568c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3945",
    "data-name": "Group 3945",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3944",
    "data-name": "Group 3944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5700",
    "data-name": "Path 5700",
    d: "M724.833,1848.947a.143.143,0,0,1-.142-.124c-.03-.215-.059-.443-.089-.682-.35-2.754-.879-6.914-5.175-10.528a.143.143,0,1,1,.185-.219c4.381,3.685,4.918,7.913,5.274,10.71.03.238.059.465.089.68a.144.144,0,0,1-.122.162Z",
    fill: "#bfbfbf"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3947",
    "data-name": "Group 3947",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3946",
    "data-name": "Group 3946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5701",
    "data-name": "Path 5701",
    d: "M752.6,1853.063a.144.144,0,0,1-.137-.1c-.019-.062-1.96-6.2-3-11.39a.143.143,0,0,1,.281-.057c1.034,5.171,2.97,11.3,2.99,11.36a.143.143,0,0,1-.094.18A.129.129,0,0,1,752.6,1853.063Z",
    fill: "#bfbfbf"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3949",
    "data-name": "Group 3949",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3948",
    "data-name": "Group 3948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5702",
    "data-name": "Path 5702",
    d: "M748.537,1897.7h-.03a.315.315,0,0,1-.249-.119c-.081-.12-.035-.268.042-.514a6.4,6.4,0,0,0,.3-2.312.143.143,0,0,1,.138-.148.145.145,0,0,1,.148.139,6.641,6.641,0,0,1-.312,2.407,2.01,2.01,0,0,0-.071.258l.026,0a4.787,4.787,0,0,0,2.035-1.649.143.143,0,1,1,.249.142C750.506,1896.447,749.127,1897.7,748.537,1897.7Z",
    fill: "#bfbfbf"
  })))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3950",
    "data-name": "Group 3950"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5703",
    "data-name": "Path 5703",
    d: "M770.183,1937.035a8.461,8.461,0,0,1-2.141-1.4,3.579,3.579,0,0,0-1.825,2.821c-2.134,3.23-7.555.726-9.93-.592-.5,3.231-.212,5.977.276,6.953h26.043C781.708,1942.722,773.775,1938.681,770.183,1937.035Z",
    fill: "#2b1710"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3951",
    "data-name": "Group 3951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5704",
    "data-name": "Path 5704",
    d: "M739.851,1821.162a1.417,1.417,0,1,1-1.212-1.532A1.383,1.383,0,0,1,739.851,1821.162Z",
    fill: "#f9c066"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3955",
    "data-name": "Group 3955"
  }, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3952",
    "data-name": "Group 3952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5705",
    "data-name": "Path 5705",
    d: "M734.618,1819.623a1.8,1.8,0,1,1-1.453-2.1A1.8,1.8,0,0,1,734.618,1819.623Z",
    fill: "#fbc585"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3954",
    "data-name": "Group 3954",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3953",
    "data-name": "Group 3953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5706",
    "data-name": "Path 5706",
    d: "M733.073,1818.036a1.279,1.279,0,0,0-1.082.3.076.076,0,0,0-.006.107.077.077,0,0,0,.107.007,1.131,1.131,0,0,1,1.411-.071c-.016,0-.031-.01-.047-.013a.769.769,0,1,0,.484,1.2,1.133,1.133,0,0,1-.617.754.076.076,0,0,0,.019.144.07.07,0,0,0,.045-.006,1.285,1.285,0,0,0-.314-2.429Zm.134,1.7a.618.618,0,1,1,.719-.5A.618.618,0,0,1,733.207,1819.733Z",
    fill: "#e0b3a8"
  }))))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3956",
    "data-name": "Group 3956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5707",
    "data-name": "Path 5707",
    d: "M742.579,1830.663a7.275,7.275,0,0,1-6.221-1.691c-1.271-1.288-1.839-3.494-2.086-5.457C734.669,1831.225,740.48,1836.289,742.579,1830.663Z",
    fill: "#f9c066"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3957",
    "data-name": "Group 3957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5708",
    "data-name": "Path 5708",
    d: "M707.247,1873.649c-.375,1.347,0,3.442,3.068,3.592C712.186,1874.166,709.112,1872.49,707.247,1873.649Z",
    fill: "#f9c066"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4037",
    "data-name": "Group 4037"
  }, _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3960",
    "data-name": "Group 3960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3959",
    "data-name": "Group 3959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5709",
    "data-name": "Path 5709",
    d: "M787.1,1845.961a.207.207,0,0,1-.086-.019,2.281,2.281,0,0,1-1.4-1.344c-.308-1.023.436-2.185,1.093-3.211.479-.746.974-1.519.784-1.9a3.109,3.109,0,0,1,.013-2.413,4.925,4.925,0,0,1,2.685-2.811c2.161-.926,2.955-2.887,2.475-4.247a4.634,4.634,0,0,1,2.279-5.781,8.62,8.62,0,0,0,4.817-6.863.216.216,0,0,1,.223-.182l15.049.794a.215.215,0,0,1,.16.086.212.212,0,0,1,.036.179c-.573,2.331.019,4.274,1.624,5.33a4.881,4.881,0,0,1,1.618,5.964c-.932,1.752-.015,3.079,2.257,5.22,1.481,1.4,1.7,4.26,1.154,6.245-.338,1.225-.916,1.987-1.63,2.146a.214.214,0,0,1-.093-.418c.536-.118,1.026-.807,1.31-1.841.521-1.892.276-4.586-1.034-5.821-2.034-1.917-3.5-3.556-2.341-5.732a4.49,4.49,0,0,0-1.475-5.406c-1.707-1.123-2.378-3.132-1.863-5.538l-14.6-.771a8.994,8.994,0,0,1-5.019,6.99,4.213,4.213,0,0,0-2.068,5.256c.538,1.525-.229,3.719-2.709,4.782a4.5,4.5,0,0,0-2.453,2.566,2.729,2.729,0,0,0-.032,2.075c.3.6-.213,1.4-.806,2.321-.607.948-1.3,2.022-1.044,2.857a1.861,1.861,0,0,0,1.16,1.076.214.214,0,0,1-.087.41Z",
    fill: "#2b1710"
  })))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3961",
    "data-name": "Group 3961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5710",
    "data-name": "Path 5710",
    d: "M818.986,1835.18c-1.923-2.425-2.592-3.093-1.923-5.016s1-3.679-1.171-5.769-1.421-3.762-1-5.435l-11.537-5.267c-2.425.418-3.846,2.509-3.846,5.267s-.5,4.682-2.843,5.937a4.822,4.822,0,0,0-2.425,5.768c.669,2.007-1.421,4.013-3.093,4.85a3.925,3.925,0,0,0-1.923,4.514c.5,1.589-1.923,1.756-1.923,3.93s4.013,1.755,4.013,1.755c2.759,1,28.677-2.006,29.262-3.929S820.909,1837.6,818.986,1835.18Z",
    fill: "#2b1710"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3964",
    "data-name": "Group 3964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3962",
    "data-name": "Group 3962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5711",
    "data-name": "Path 5711",
    d: "M850.963,1938.8a14.073,14.073,0,0,0,1.078-6.729c-.169-1.221-.379-2.762-.614-4.527-.116-.878-.239-1.811-.366-2.788l5.848,1.566c-.1,1.053-.193,2.04-.279,2.942a21.174,21.174,0,0,0,.22,5.765,5.845,5.845,0,0,0,.351,1.323c.465.942,3.822,4.2,5.356,7.005.144.341,3.613.889,3.092,1.685-.315.174-6.365.649-7.042,0s-2.287-2.274-4.088-2.639a25.954,25.954,0,0,0-.113,2.938l-2.619.011s-.3-2.59-.42-3.372S850.36,1940.006,850.963,1938.8Z",
    fill: "#fbc585"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3963",
    "data-name": "Group 3963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5712",
    "data-name": "Path 5712",
    d: "M862.578,1943.389a9.071,9.071,0,0,1-2.716.183c-.567-.248-4.3-4.885-8.407-6.027a8.306,8.306,0,0,1-.493,1.255c-.6,1.206.289,2.4.405,3.177s.42,3.372.42,3.372l2.619-.011a25.954,25.954,0,0,1,.113-2.938c1.8.364,3.411,1.988,4.088,2.639s6.727.177,7.042,0C866.155,1944.27,862.9,1943.754,862.578,1943.389Z",
    fill: "#2b1710"
  })))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3965",
    "data-name": "Group 3965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5713",
    "data-name": "Path 5713",
    d: "M855.922,1888.868c-5.25-9.574-20.035-17.349-22.545-18.221a108.939,108.939,0,0,1-19.3-9.413l-5.017-1-2.173,15.049,6.828,5.97c3.5,8.442,25.324,9.471,27.383,14.412s8.338,38.3,8.338,38.3h14.31S861.172,1898.442,855.922,1888.868Z",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3967",
    "data-name": "Group 3967",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3966",
    "data-name": "Group 3966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5714",
    "data-name": "Path 5714",
    d: "M862.54,1930.836a.2.2,0,0,0,0-.4l-13.28-.051h0a.2.2,0,1,0,0,.394l13.279.052Z",
    fill: "#d4d4d4"
  })))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3968",
    "data-name": "Group 3968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5715",
    "data-name": "Path 5715",
    d: "M814.671,1832.414c6.214,2.775,12.9,15.149,16.08,19.162s9.531,6.187,9.531,6.187-9.531,4.18-11.7,4.347c-10.7-4.18-15.049-14.547-15.049-14.547Z",
    fill: "url(#linear-gradient-10)"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3971",
    "data-name": "Group 3971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3969",
    "data-name": "Group 3969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5716",
    "data-name": "Path 5716",
    d: "M833.015,1938.8a14.073,14.073,0,0,0,1.078-6.729c-.168-1.221-.378-2.762-.613-4.527-.117-.878-.24-1.811-.367-2.788l5.849,1.566c-.1,1.053-.194,2.04-.279,2.942a21.133,21.133,0,0,0,.22,5.765,5.852,5.852,0,0,0,.35,1.323c.465.942,3.823,4.2,5.357,7.005.144.341,3.612.889,3.092,1.685-.316.174-6.365.649-7.042,0s-2.287-2.274-4.088-2.639a25.954,25.954,0,0,0-.113,2.938l-2.619.011s-.3-2.59-.42-3.372S832.413,1940.006,833.015,1938.8Z",
    fill: "#fbc585"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3970",
    "data-name": "Group 3970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5717",
    "data-name": "Path 5717",
    d: "M844.631,1943.389a9.072,9.072,0,0,1-2.716.183c-.567-.248-4.3-4.885-8.408-6.027a8.32,8.32,0,0,1-.492,1.255c-.6,1.206.289,2.4.4,3.177s.42,3.372.42,3.372l2.619-.011a25.954,25.954,0,0,1,.113-2.938c1.8.364,3.411,1.988,4.088,2.639s6.726.177,7.042,0C848.207,1944.27,844.951,1943.754,844.631,1943.389Z",
    fill: "#2b1710"
  })))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3972",
    "data-name": "Group 3972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5718",
    "data-name": "Path 5718",
    d: "M811.007,1831.86l3.664.554c.463,5.018,5.018,10.423,5.25,13.2s-3.4,6.949-4.864,9.574a11.163,11.163,0,0,0-1.467,4.941H798.226c0-.695-3.706-17.912-3.243-22.158s5.926-5.839,5.926-5.839A51.642,51.642,0,0,0,811.007,1831.86Z",
    fill: "url(#linear-gradient-11)"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3973",
    "data-name": "Group 3973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5719",
    "data-name": "Path 5719",
    d: "M798.68,1861.152s-6.794,11.53-3.294,19.971,25.324,9.471,27.383,14.412,8.338,38.295,8.338,38.295h14.309s-2.573-35.515-7.823-45.089-20.383-16.677-22.545-18.221-4.323-9.883-4.323-9.883Z",
    fill: "url(#linear-gradient-12)"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3974",
    "data-name": "Group 3974"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 16.098,
    height: 1.467,
    transform: "translate(814.053 1861.251) rotate(180)",
    fill: "#2b1710"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3975",
    "data-name": "Group 3975"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 0.772,
    height: 2.316,
    transform: "translate(805.14 1859.273)",
    fill: "#5a52f0"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3976",
    "data-name": "Group 3976"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 0.772,
    height: 2.316,
    transform: "translate(799.684 1859.273)",
    fill: "#5a52f0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3978",
    "data-name": "Group 3978",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3977",
    "data-name": "Group 3977"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5720",
    "data-name": "Path 5720",
    d: "M800.018,1871.953a.188.188,0,0,0,.047-.006c3.548-.86,5.3-4.706,4.472-9.8a.2.2,0,0,0-.39.063c.8,4.873-.843,8.543-4.175,9.351a.2.2,0,0,0,.046.389Z",
    fill: "#d4d4d4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3980",
    "data-name": "Group 3980",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3979",
    "data-name": "Group 3979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5721",
    "data-name": "Path 5721",
    d: "M835.122,1930.115l.037,0a.2.2,0,0,0,.157-.231c-.244-1.291-6.01-31.7-8.974-37.625-1.94-3.881-9.723-5.879-15.977-7.485-3.6-.925-6.716-1.725-8.071-2.677-3.867-2.717-3.4-11.993-1.671-19.767a.2.2,0,0,0-.385-.085c-1.756,7.9-2.2,17.346,1.829,20.175,1.414.994,4.559,1.8,8.2,2.736,6.176,1.586,13.863,3.56,15.722,7.279,2.94,5.878,8.879,37.207,8.939,37.523A.2.2,0,0,0,835.122,1930.115Z",
    fill: "#d4d4d4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3982",
    "data-name": "Group 3982",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3981",
    "data-name": "Group 3981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5722",
    "data-name": "Path 5722",
    d: "M844.593,1930.836a.2.2,0,0,0,0-.4l-13.28-.051h0a.2.2,0,0,0,0,.394l13.28.052Z",
    fill: "#d4d4d4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3992",
    "data-name": "Group 3992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3990",
    "data-name": "Group 3990"
  }, _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3983",
    "data-name": "Group 3983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5723",
    "data-name": "Path 5723",
    d: "M788.219,1850.348a51.907,51.907,0,0,0-2.066,13.665c.133,6.4,3.066,15.2,3.066,16.131a3.837,3.837,0,0,0,3.933,3.867c1.6-.2,2.633-.4,2.8-.034.2.567,1.266,1.433,1.766,1.3a1.076,1.076,0,0,0,1,.167.66.66,0,0,0,.833-.133,7.97,7.97,0,0,0-.133-1.634c-.133-.266-.433-1.133-.433-1.133s.7.633.733.967-.067,1.4.4,1.5a5.609,5.609,0,0,0,.2-2.334c-.033-.466-1.1-2.133-2-2.3s-4.533-.1-4.8-.434.833-16.465,1.133-17.964,3.3-10.1,3.3-10.1Z",
    fill: "#fbc585"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3985",
    "data-name": "Group 3985",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3984",
    "data-name": "Group 3984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5724",
    "data-name": "Path 5724",
    d: "M798.777,1882.2a.1.1,0,0,1-.071-.031l-.525-.575a.1.1,0,1,1,.141-.129l.525.575a.1.1,0,0,1-.006.135A.093.093,0,0,1,798.777,1882.2Z",
    fill: "#e0b3a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3987",
    "data-name": "Group 3987",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3986",
    "data-name": "Group 3986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5725",
    "data-name": "Path 5725",
    d: "M798.607,1884.992s-.2-1.249-.225-1.4a10.374,10.374,0,0,0-.758-1.16.1.1,0,0,1,.022-.134.1.1,0,0,1,.134.023,8.626,8.626,0,0,1,.791,1.24c.025.15.225,1.4.225,1.4Z",
    fill: "#e0b3a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3989",
    "data-name": "Group 3989",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3988",
    "data-name": "Group 3988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5726",
    "data-name": "Path 5726",
    d: "M797.7,1884.9a.1.1,0,0,1-.091-.065c0-.008-.25-.749-.3-.87-.033-.075-.425-.567-.785-1a.1.1,0,1,1,.147-.123,12.186,12.186,0,0,1,.816,1.051c.05.126.291.849.3.88a.1.1,0,0,1-.061.121A.1.1,0,0,1,797.7,1884.9Z",
    fill: "#e0b3a8"
  }))))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3991",
    "data-name": "Group 3991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5727",
    "data-name": "Path 5727",
    d: "M797.136,1834.233c4.941,3.551,4.324,11.117,1.853,17.14s-4.478,12.2-4.478,23.934c-4.787.926-6.64.309-6.64.309s-3.706-10.655-1.544-21.155S793.121,1834.233,797.136,1834.233Z",
    fill: "url(#linear-gradient-10)"
  })))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3997",
    "data-name": "Group 3997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3993",
    "data-name": "Group 3993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5728",
    "data-name": "Path 5728",
    d: "M848.5,1855.7H820.942l-4.781,20.329h27.562Z",
    fill: "#56568c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3994",
    "data-name": "Group 3994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5729",
    "data-name": "Path 5729",
    d: "M849.7,1855.7H822.137l-4.781,20.329h27.562Z",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3995",
    "data-name": "Group 3995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5730",
    "data-name": "Path 5730",
    d: "M834.278,1867.393h-3.245v-1.312a1.744,1.744,0,0,1,1.745-1.744h3.244v1.311A1.744,1.744,0,0,1,834.278,1867.393Z",
    fill: "#c4c3f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3996",
    "data-name": "Group 3996"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 38.163,
    height: 1.808,
    transform: "translate(806.631 1876.029)",
    fill: "#56568c"
  })))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3998",
    "data-name": "Group 3998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5731",
    "data-name": "Path 5731",
    d: "M849.286,1866.887c2.016-1.458,2.831-6.477-.515-7.549a7.982,7.982,0,0,0-.3,1.458s-5.019.472-5.233,2.016a1.26,1.26,0,0,0,.085,1.716c-.085.9,2.1,1.458,2.1,1.458s-1.329-.257-1.287.386S847.784,1867.53,849.286,1866.887Z",
    fill: "#fbc585"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4000",
    "data-name": "Group 4000",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3999",
    "data-name": "Group 3999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5732",
    "data-name": "Path 5732",
    d: "M844.823,1863.273a9.316,9.316,0,0,0,4.017-.734.055.055,0,0,0,.022-.074.055.055,0,0,0-.074-.023c-1.809.968-5.062.683-5.1.68a.056.056,0,0,0-.06.05.055.055,0,0,0,.05.059C843.7,1863.232,844.155,1863.273,844.823,1863.273Z",
    fill: "#e0b3a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4002",
    "data-name": "Group 4002",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4001",
    "data-name": "Group 4001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5733",
    "data-name": "Path 5733",
    d: "M847.466,1865.183h.019a.055.055,0,0,0,.054-.055.053.053,0,0,0-.056-.054,15.058,15.058,0,0,1-3.929-.577.055.055,0,1,0-.032.105A15.192,15.192,0,0,0,847.466,1865.183Z",
    fill: "#e0b3a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4004",
    "data-name": "Group 4004",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4003",
    "data-name": "Group 4003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5734",
    "data-name": "Path 5734",
    d: "M846.673,1866.2c.1,0,.165,0,.172-.005a.055.055,0,1,0-.009-.109,4.2,4.2,0,0,1-1.2-.127.054.054,0,0,0-.067.039.056.056,0,0,0,.04.067A4.519,4.519,0,0,0,846.673,1866.2Z",
    fill: "#e0b3a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4033",
    "data-name": "Group 4033"
  }, _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4005",
    "data-name": "Group 4005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5735",
    "data-name": "Path 5735",
    d: "M805.492,1826.6a4.132,4.132,0,0,1-4.773-5.505c-.3-5.547,2.064-11.008,10.363-8.041,4.129.516,5.72,5.977,2.323,7.4A69.063,69.063,0,0,1,805.492,1826.6Z",
    fill: "#2b1710"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4006",
    "data-name": "Group 4006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5736",
    "data-name": "Path 5736",
    d: "M808.8,1828.725a2.62,2.62,0,0,0,2.264,3.139c-.065,6.967-10.584,1.473-10.552.441,0-.129,1.87-.548,2.548-1.741s1-4.225.741-8.289c1.581.419,2.129-.839,2.161-3s1.065-5.612,5.257-5.064c1.581,1.935,2.419,3.161,2.29,5.676s.151,4.3-.15,5.505A4.478,4.478,0,0,1,808.8,1828.725Z",
    fill: "#fbc585"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4007",
    "data-name": "Group 4007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5737",
    "data-name": "Path 5737",
    d: "M809.475,1823.945a1.315,1.315,0,1,1-1.125-1.422A1.283,1.283,0,0,1,809.475,1823.945Z",
    fill: "#f9c066"
  }))), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 3,
    height: 2,
    transform: "translate(810 1822.332)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAYAAACddGYaAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAiSURBVBhXY/x5IO0/852/DMyv/jEw/P//n+HP/GQg9Z8BAMjgD95XnAvXAAAAAElFTkSuQmCC"
  })), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4009",
    "data-name": "Group 4009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4008",
    "data-name": "Group 4008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5738",
    "data-name": "Path 5738",
    d: "M806.46,1819.455a.082.082,0,0,1-.072-.042c-.022-.039,0-.075.031-.112.723-1.011,2.237-1.8,2.881-.5.021.041.069.059.055.1a.083.083,0,0,1-.1.055,4.145,4.145,0,0,0-2.751.487A.086.086,0,0,1,806.46,1819.455Z",
    fill: "#2b1710"
  })))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4011",
    "data-name": "Group 4011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4010",
    "data-name": "Group 4010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5739",
    "data-name": "Path 5739",
    d: "M813.19,1819.541a.084.084,0,0,1-.066-.033c-.014-.018-.347-.444-1.408-.312a.082.082,0,0,1-.092-.071c-.005-.046.053-.051.072-.092.584-1.28,1.519.322,1.56.376a.083.083,0,0,1-.066.132Z",
    fill: "#2b1710"
  })))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4013",
    "data-name": "Group 4013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4012",
    "data-name": "Group 4012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5740",
    "data-name": "Path 5740",
    d: "M811.276,1823.927a.086.086,0,0,1-.065-.031.083.083,0,0,1,.014-.116,8.248,8.248,0,0,0,1-.9,2.426,2.426,0,0,0-.352-.021,2,2,0,0,1-.835-.124c-.441-.248-.015-2.111.374-2.987a.082.082,0,0,1,.15.067c-.452,1.018-.709,2.627-.443,2.776a1.95,1.95,0,0,0,.757.1c.332.007.532.01.532.162s-.59.66-1.085,1.054A.082.082,0,0,1,811.276,1823.927Z",
    fill: "#2b1710"
  })))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4014",
    "data-name": "Group 4014"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 0.5,
    cy: 0.887,
    rx: 0.5,
    ry: 0.887,
    transform: "translate(807.771 1820.275)",
    fill: "#2b1710"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4016",
    "data-name": "Group 4016",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4015",
    "data-name": "Group 4015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5741",
    "data-name": "Path 5741",
    d: "M808.158,1822.35c-.172,0-.551-.074-.674-.7a.041.041,0,0,1,.032-.049.042.042,0,0,1,.049.033c.119.61.482.646.633.633a.041.041,0,0,1,.007.082Z",
    fill: "#e0b3a8"
  })))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4017",
    "data-name": "Group 4017"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 0.5,
    cy: 0.887,
    rx: 0.5,
    ry: 0.887,
    transform: "translate(811.555 1820.383)",
    fill: "#2b1710"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4019",
    "data-name": "Group 4019",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4018",
    "data-name": "Group 4018"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5742",
    "data-name": "Path 5742",
    d: "M811.942,1822.458c-.172,0-.551-.074-.674-.7a.04.04,0,0,1,.032-.048.041.041,0,0,1,.049.032c.119.61.482.646.633.634a.04.04,0,0,1,.045.037.042.042,0,0,1-.038.045Z",
    fill: "#e0b3a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4021",
    "data-name": "Group 4021",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4020",
    "data-name": "Group 4020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5743",
    "data-name": "Path 5743",
    d: "M808.962,1824.874c1.452-.44,3.041-.331,3.185.135A4.918,4.918,0,0,1,808.962,1824.874Z",
    fill: "#e0b3a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4023",
    "data-name": "Group 4023",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4022",
    "data-name": "Group 4022"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5744",
    "data-name": "Path 5744",
    d: "M810.59,1826.777a1.511,1.511,0,0,1-.823-.2.075.075,0,0,1-.022-.1.075.075,0,0,1,.1-.021,2.043,2.043,0,0,0,1.593.023.077.077,0,0,1,.1.014.074.074,0,0,1-.011.1A2.147,2.147,0,0,1,810.59,1826.777Z",
    fill: "#e0b3a8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4025",
    "data-name": "Group 4025",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4024",
    "data-name": "Group 4024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5745",
    "data-name": "Path 5745",
    d: "M812.095,1825.134c-.639,1.642-1.768,1.448-3.119-.188A6.083,6.083,0,0,0,812.095,1825.134Z",
    fill: "#e0b3a8"
  })))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4026",
    "data-name": "Group 4026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5746",
    "data-name": "Path 5746",
    d: "M810.962,1825.305a5.376,5.376,0,0,1-2.116-.359.075.075,0,1,1,.066-.134,5.72,5.72,0,0,0,3.235.2.075.075,0,0,1,.1.029.076.076,0,0,1-.03.1A3.377,3.377,0,0,1,810.962,1825.305Z",
    fill: "#2b1710"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4031",
    "data-name": "Group 4031"
  }, _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5747",
    "data-name": "Path 5747",
    d: "M804.277,1822.972a1.024,1.024,0,1,1-.825-1.191A1.025,1.025,0,0,1,804.277,1822.972Z",
    fill: "#f9c066"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4030",
    "data-name": "Group 4030",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5748",
    "data-name": "Path 5748",
    d: "M803.4,1822.071a.726.726,0,0,0-.614.171.043.043,0,0,0,.057.065.641.641,0,0,1,.8-.04l-.027-.008a.437.437,0,1,0,.275.685.643.643,0,0,1-.35.428.043.043,0,0,0-.021.057.042.042,0,0,0,.031.024.039.039,0,0,0,.026,0,.73.73,0,0,0-.178-1.379Zm.076.963a.351.351,0,1,1,.408-.282A.35.35,0,0,1,803.476,1823.034Z",
    fill: "#e0b3a8"
  }))))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4032",
    "data-name": "Group 4032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5749",
    "data-name": "Path 5749",
    d: "M808.587,1828.63a5.646,5.646,0,0,1-3.643-3.236C806.511,1830.788,808.383,1832.436,808.587,1828.63Z",
    fill: "#f9c066"
  })))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4034",
    "data-name": "Group 4034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5750",
    "data-name": "Path 5750",
    d: "M811.222,1814.212c-.8,4.028-7.4,4.614-7.4,4.614l1.087-5.017,4.849-.418Z",
    fill: "#2b1710"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4036",
    "data-name": "Group 4036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4035",
    "data-name": "Group 4035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5751",
    "data-name": "Path 5751",
    d: "M821.542,1833.838a.221.221,0,0,1-.075-.014c-.074-.028-1.818-.7-2.233-1.959a1.923,1.923,0,0,1,.29-1.7c1.339-2.07.477-5.59-1.739-7.107-2.4-1.639-3.037-3.447-3.436-6.418a.214.214,0,1,1,.424-.057c.382,2.846.99,4.574,3.253,6.122,2.434,1.666,3.337,5.4,1.856,7.692a1.5,1.5,0,0,0-.242,1.335c.352,1.07,1.961,1.687,1.977,1.693a.214.214,0,0,1-.075.414Z",
    fill: "#2b1710"
  }))))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4069",
    "data-name": "Group 4069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4038",
    "data-name": "Group 4038"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 77.631,
    height: 45.815,
    rx: 9.652,
    transform: "translate(739.973 1725.93)",
    fill: "#fe496e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4039",
    "data-name": "Group 4039"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 77.631,
    height: 45.815,
    rx: 9.652,
    transform: "translate(735.9 1719.567)",
    fill: "#ff698e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4041",
    "data-name": "Group 4041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4040",
    "data-name": "Group 4040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5752",
    "data-name": "Path 5752",
    d: "M862.655,1797.3v-33.918a5.195,5.195,0,0,0-5.186-5.185H794.028a5.186,5.186,0,0,0-5.186,5.185v4.105h0v30.575a5.186,5.186,0,0,0,5.186,5.186h55.538l18.4,10.626Z",
    fill: "#fe496e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4055",
    "data-name": "Group 4055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4042",
    "data-name": "Group 4042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5753",
    "data-name": "Path 5753",
    d: "M862.877,1808.015l-5.313-16.574v-33.918a5.186,5.186,0,0,0-5.186-5.186H788.937a5.186,5.186,0,0,0-5.186,5.186v34.68a5.186,5.186,0,0,0,5.186,5.186h55.538Z",
    fill: "#ff698e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4044",
    "data-name": "Group 4044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4043",
    "data-name": "Group 4043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5754",
    "data-name": "Path 5754",
    d: "M852.378,1752.337H788.937a5.186,5.186,0,0,0-5.186,5.186v4.105h73.813v-4.105A5.186,5.186,0,0,0,852.378,1752.337Z",
    fill: "#ffc5d4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4045",
    "data-name": "Group 4045"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 2.863,
    cy: 2.863,
    r: 2.863,
    transform: "translate(786.901 1754.183)",
    fill: "#ff698e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4046",
    "data-name": "Group 4046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5755",
    "data-name": "Path 5755",
    d: "M825.414,1759.051h-26.63a1.862,1.862,0,0,1-1.861-1.862h0a1.861,1.861,0,0,1,1.861-1.861h26.63a1.862,1.862,0,0,1,1.862,1.861h0A1.862,1.862,0,0,1,825.414,1759.051Z",
    fill: "#ff698e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4047",
    "data-name": "Group 4047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5756",
    "data-name": "Path 5756",
    d: "M854.049,1758h-8.925a.763.763,0,0,1-.763-.764h0a.762.762,0,0,1,.763-.763h8.925a.763.763,0,0,1,.763.763h0A.764.764,0,0,1,854.049,1758Z",
    fill: "#ff698e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4048",
    "data-name": "Group 4048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5757",
    "data-name": "Path 5757",
    d: "M854.049,1755.561h-8.925a.762.762,0,0,1-.763-.763h0a.763.763,0,0,1,.763-.764h8.925a.764.764,0,0,1,.763.764h0A.763.763,0,0,1,854.049,1755.561Z",
    fill: "#ff698e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4049",
    "data-name": "Group 4049"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5758",
    "data-name": "Path 5758",
    d: "M854.049,1760.44h-8.925a.763.763,0,0,1-.763-.764h0a.763.763,0,0,1,.763-.763h8.925a.764.764,0,0,1,.763.763h0A.764.764,0,0,1,854.049,1760.44Z",
    fill: "#ff698e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4050",
    "data-name": "Group 4050"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 31.434,
    height: 6.872,
    rx: 3.13,
    transform: "translate(787.697 1767.927)",
    fill: "#ffdce6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4051",
    "data-name": "Group 4051"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 19.853,
    height: 6.872,
    rx: 3.13,
    transform: "translate(787.697 1781.099)",
    fill: "#ffdce6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4052",
    "data-name": "Group 4052"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 34.446,
    height: 6.872,
    rx: 3.13,
    transform: "translate(810.137 1781.099)",
    fill: "#ffdce6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4053",
    "data-name": "Group 4053"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 6.872,
    height: 6.872,
    rx: 3.13,
    transform: "translate(822.333 1767.927)",
    fill: "#ffdce6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4054",
    "data-name": "Group 4054"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 18.114,
    height: 6.872,
    rx: 3.13,
    transform: "translate(832.578 1767.927)",
    fill: "#ffdce6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4056",
    "data-name": "Group 4056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5759",
    "data-name": "Path 5759",
    d: "M808.822,1719.567H740.609a4.709,4.709,0,0,0-4.709,4.709v4.2h77.631v-4.2A4.709,4.709,0,0,0,808.822,1719.567Z",
    fill: "#ffc5d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4057",
    "data-name": "Group 4057"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5760",
    "data-name": "Path 5760",
    d: "M799.3,1724.085a1.209,1.209,0,1,1-1.209-1.209A1.209,1.209,0,0,1,799.3,1724.085Z",
    fill: "#ff698e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4058",
    "data-name": "Group 4058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5761",
    "data-name": "Path 5761",
    d: "M804.665,1724.085a1.209,1.209,0,1,1-1.209-1.209A1.209,1.209,0,0,1,804.665,1724.085Z",
    fill: "#ff698e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4059",
    "data-name": "Group 4059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5762",
    "data-name": "Path 5762",
    d: "M810.031,1724.085a1.209,1.209,0,1,1-1.209-1.209A1.209,1.209,0,0,1,810.031,1724.085Z",
    fill: "#ff698e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4060",
    "data-name": "Group 4060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5763",
    "data-name": "Path 5763",
    d: "M749.2,1739.2h-6.108a2.673,2.673,0,0,1-2.673-2.673h0a2.673,2.673,0,0,1,2.673-2.673H749.2a2.673,2.673,0,0,1,2.673,2.673h0A2.673,2.673,0,0,1,749.2,1739.2Z",
    fill: "#ffdce6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4061",
    "data-name": "Group 4061"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5764",
    "data-name": "Path 5764",
    d: "M765.044,1749.442H743.091a2.672,2.672,0,0,1-2.673-2.672h0a2.673,2.673,0,0,1,2.673-2.673h21.953a2.672,2.672,0,0,1,2.672,2.673h0A2.672,2.672,0,0,1,765.044,1749.442Z",
    fill: "#ffdce6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4062",
    "data-name": "Group 4062"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5765",
    "data-name": "Path 5765",
    d: "M778.6,1749.442h-5.748a2.672,2.672,0,0,1-2.672-2.672h0a2.672,2.672,0,0,1,2.672-2.673H778.6a2.673,2.673,0,0,1,2.673,2.673h0A2.673,2.673,0,0,1,778.6,1749.442Z",
    fill: "#ffdce6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4063",
    "data-name": "Group 4063"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 20.882,
    height: 5.345,
    rx: 2.673,
    transform: "translate(785.3 1744.097)",
    fill: "#ffdce6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4064",
    "data-name": "Group 4064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5766",
    "data-name": "Path 5766",
    d: "M758.214,1739.2h0a2.673,2.673,0,0,1-2.673-2.673h0a2.673,2.673,0,0,1,2.673-2.673h0a2.672,2.672,0,0,1,2.672,2.673h0A2.672,2.672,0,0,1,758.214,1739.2Z",
    fill: "#ffdce6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4065",
    "data-name": "Group 4065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5767",
    "data-name": "Path 5767",
    d: "M755.051,1759.2h-11.96a2.672,2.672,0,0,1-2.673-2.672h0a2.673,2.673,0,0,1,2.673-2.673h11.96a2.673,2.673,0,0,1,2.672,2.673h0A2.672,2.672,0,0,1,755.051,1759.2Z",
    fill: "#ffdce6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4066",
    "data-name": "Group 4066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5768",
    "data-name": "Path 5768",
    d: "M768.671,1759.2H765.94a2.672,2.672,0,0,1-2.672-2.672h0a2.672,2.672,0,0,1,2.672-2.673h2.731a2.673,2.673,0,0,1,2.672,2.673h0A2.672,2.672,0,0,1,768.671,1759.2Z",
    fill: "#ffdce6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4067",
    "data-name": "Group 4067"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5769",
    "data-name": "Path 5769",
    d: "M789.765,1739.2h-22.77a2.672,2.672,0,0,1-2.672-2.673h0a2.672,2.672,0,0,1,2.672-2.672h22.77a2.672,2.672,0,0,1,2.672,2.672h0A2.672,2.672,0,0,1,789.765,1739.2Z",
    fill: "#ffdce6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4068",
    "data-name": "Group 4068"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 10.255,
    height: 5.345,
    rx: 2.673,
    transform: "translate(795.545 1733.853)",
    fill: "#ffdce6"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero2);
export default __webpack_public_path__ + "static/media/hero-2.9e799c2ec4089304b4f70d22b53dfd94.svg";
export { ForwardRef as ReactComponent };